var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _g, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 343,
    viewBox: "0 0 460 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460 301.199H0V301.429H460V301.199Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M413.908 316.001H383.438V316.231H413.908V316.001Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M304.722 318.504H296.728V318.734H304.722V318.504Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M382.518 307.464H364.863V307.694H382.518V307.464Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.998 309.01H48.2632V309.24H87.998V309.01Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.019 309.01H96.1953V309.24H102.019V309.01Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M207.138 312.892H120.952V313.122H207.138V312.892Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.04 260.168H40.3971C39.0054 260.166 37.6716 259.611 36.6884 258.626C35.7053 257.642 35.1531 256.307 35.1531 254.915V5.20705C35.1652 3.82343 35.7227 2.50047 36.7046 1.52552C37.6865 0.550565 39.0134 0.00237021 40.3971 0H218.04C219.433 0 220.769 0.553444 221.754 1.53858C222.74 2.52372 223.293 3.85985 223.293 5.25304V254.915C223.293 256.308 222.74 257.645 221.754 258.63C220.769 259.615 219.433 260.168 218.04 260.168ZM40.3971 0.183995C39.0664 0.186432 37.7911 0.716719 36.8511 1.65846C35.911 2.6002 35.3831 3.87644 35.3831 5.20705V254.915C35.3831 256.246 35.911 257.522 36.8511 258.464C37.7911 259.406 39.0664 259.936 40.3971 259.938H218.04C219.371 259.936 220.648 259.406 221.589 258.464C222.531 257.523 223.061 256.247 223.063 254.915V5.20705C223.061 3.8756 222.531 2.59938 221.589 1.6579C220.648 0.71642 219.371 0.186427 218.04 0.183995H40.3971Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M417.045 260.168H239.393C238.001 260.166 236.666 259.612 235.681 258.627C234.697 257.642 234.143 256.308 234.14 254.915V5.20705C234.155 3.82259 234.714 2.49964 235.698 1.52494C236.681 0.550244 238.009 0.00234436 239.393 0H417.045C418.427 0.004788 419.752 0.554053 420.732 1.52874C421.712 2.50344 422.268 3.82502 422.28 5.20705V254.915C422.28 256.305 421.729 257.639 420.748 258.623C419.767 259.608 418.435 260.163 417.045 260.168ZM239.393 0.183995C238.062 0.186427 236.786 0.71642 235.844 1.6579C234.903 2.59938 234.373 3.8756 234.37 5.20705V254.915C234.373 256.247 234.903 257.523 235.844 258.464C236.786 259.406 238.062 259.936 239.393 259.938H417.045C418.377 259.936 419.653 259.406 420.595 258.464C421.536 257.523 422.066 256.247 422.069 254.915V5.20705C422.066 3.8756 421.536 2.59938 420.595 1.6579C419.653 0.71642 418.377 0.186427 417.045 0.183995H239.393Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M409.787 57.2039H186.889V272.054H409.787V57.2039Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M409.787 61.1046H190.468V268.301H409.787V61.1046Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M192.087 218.126V155.797H198.555V147.564L213.127 140.756V132.329H215.556V155.797H217.985V218.126H221.223V185.743H228.51V168.751H230.939V218.126H236.597V199.505H240.645V194.648H249.55V177.656H254.408V166.322H260.075V149.321H262.504V166.322H268.171V177.656H273.019V194.648H281.925V199.505H285.973V218.126H290.831V194.648H299.736V142.853H302.165V137.186H321.586V142.853H325.634V180.085H341.826V184.123H347.484V186.552H341.826V201.124H358.819V152.559H362.057V142.853H370.153V105.622H372.582V142.853H378.249V152.559H409.787V268.301H190.468V218.126H192.087Z",
    fill: "#E6E6E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M392.932 155.098H390.641V157.389H392.932V155.098Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M392.932 158.944H390.641V161.234H392.932V158.944Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M392.932 174.326H390.641V176.616H392.932V174.326Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M392.932 178.162H390.641V180.453H392.932V178.162Z",
    fill: "#F0F0F0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M392.932 182.007H390.641V184.298H392.932V182.007Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M392.932 193.544H390.641V195.835H392.932V193.544Z",
    fill: "#F0F0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M392.932 197.389H390.641V199.68H392.932V197.389Z",
    fill: "#F0F0F0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M389.289 170.48H386.998V172.771H389.289V170.48Z",
    fill: "#F0F0F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M389.289 174.326H386.998V176.616H389.289V174.326Z",
    fill: "#F0F0F0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M389.289 178.162H386.998V180.453H389.289V178.162Z",
    fill: "#F0F0F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M389.289 182.007H386.998V184.298H389.289V182.007Z",
    fill: "#F0F0F0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M389.289 185.853H386.998V188.144H389.289V185.853Z",
    fill: "#F0F0F0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M389.289 193.544H386.998V195.835H389.289V193.544Z",
    fill: "#F0F0F0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M389.289 197.389H386.998V199.68H389.289V197.389Z",
    fill: "#F0F0F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M385.646 155.098H383.355V157.389H385.646V155.098Z",
    fill: "#F0F0F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M385.646 158.944H383.355V161.234H385.646V158.944Z",
    fill: "#F0F0F0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M385.646 162.789H383.355V165.08H385.646V162.789Z",
    fill: "#F0F0F0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M385.646 166.635H383.355V168.925H385.646V166.635Z",
    fill: "#F0F0F0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M385.646 170.48H383.355V172.771H385.646V170.48Z",
    fill: "#F0F0F0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M385.646 174.326H383.355V176.616H385.646V174.326Z",
    fill: "#F0F0F0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M385.646 178.162H383.355V180.453H385.646V178.162Z",
    fill: "#F0F0F0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M385.646 182.007H383.355V184.298H385.646V182.007Z",
    fill: "#F0F0F0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M385.646 185.853H383.355V188.144H385.646V185.853Z",
    fill: "#F0F0F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M385.646 189.698H383.355V191.989H385.646V189.698Z",
    fill: "#F0F0F0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M385.646 197.389H383.355V199.68H385.646V197.389Z",
    fill: "#F0F0F0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M382.002 155.098H379.712V157.389H382.002V155.098Z",
    fill: "#F0F0F0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M382.002 158.944H379.712V161.234H382.002V158.944Z",
    fill: "#F0F0F0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M382.002 162.789H379.712V165.08H382.002V162.789Z",
    fill: "#F0F0F0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M382.002 166.635H379.712V168.925H382.002V166.635Z",
    fill: "#F0F0F0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M382.002 170.48H379.712V172.771H382.002V170.48Z",
    fill: "#F0F0F0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M382.002 174.326H379.712V176.616H382.002V174.326Z",
    fill: "#F0F0F0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M382.002 178.162H379.712V180.453H382.002V178.162Z",
    fill: "#F0F0F0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M382.002 212.771H379.712V215.062H382.002V212.771Z",
    fill: "#F0F0F0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 155.098H376.068V157.389H378.359V155.098Z",
    fill: "#F0F0F0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 158.944H376.068V161.234H378.359V158.944Z",
    fill: "#F0F0F0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 162.789H376.068V165.08H378.359V162.789Z",
    fill: "#F0F0F0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 166.635H376.068V168.925H378.359V166.635Z",
    fill: "#F0F0F0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 170.48H376.068V172.771H378.359V170.48Z",
    fill: "#F0F0F0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 174.326H376.068V176.616H378.359V174.326Z",
    fill: "#F0F0F0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 178.162H376.068V180.453H378.359V178.162Z",
    fill: "#F0F0F0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 182.007H376.068V184.298H378.359V182.007Z",
    fill: "#F0F0F0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 205.08H376.068V207.371H378.359V205.08Z",
    fill: "#F0F0F0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 208.926H376.068V211.217H378.359V208.926Z",
    fill: "#F0F0F0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 212.771H376.068V215.062H378.359V212.771Z",
    fill: "#F0F0F0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 216.608H376.068V218.898H378.359V216.608Z",
    fill: "#F0F0F0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M378.359 231.99H376.068V234.28H378.359V231.99Z",
    fill: "#F0F0F0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 155.098H372.425V157.389H374.716V155.098Z",
    fill: "#F0F0F0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 158.944H372.425V161.234H374.716V158.944Z",
    fill: "#F0F0F0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 162.789H372.425V165.08H374.716V162.789Z",
    fill: "#F0F0F0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 166.635H372.425V168.925H374.716V166.635Z",
    fill: "#F0F0F0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 170.48H372.425V172.771H374.716V170.48Z",
    fill: "#F0F0F0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 174.326H372.425V176.616H374.716V174.326Z",
    fill: "#F0F0F0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 178.162H372.425V180.453H374.716V178.162Z",
    fill: "#F0F0F0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 182.007H372.425V184.298H374.716V182.007Z",
    fill: "#F0F0F0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 185.853H372.425V188.144H374.716V185.853Z",
    fill: "#F0F0F0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 189.698H372.425V191.989H374.716V189.698Z",
    fill: "#F0F0F0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 201.235H372.425V203.526H374.716V201.235Z",
    fill: "#F0F0F0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 205.08H372.425V207.371H374.716V205.08Z",
    fill: "#F0F0F0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 208.926H372.425V211.217H374.716V208.926Z",
    fill: "#F0F0F0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 212.771H372.425V215.062H374.716V212.771Z",
    fill: "#F0F0F0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 216.608H372.425V218.898H374.716V216.608Z",
    fill: "#F0F0F0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M374.716 231.99H372.425V234.28H374.716V231.99Z",
    fill: "#F0F0F0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 155.098H368.782V157.389H371.073V155.098Z",
    fill: "#F0F0F0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 158.944H368.782V161.234H371.073V158.944Z",
    fill: "#F0F0F0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 162.789H368.782V165.08H371.073V162.789Z",
    fill: "#F0F0F0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 166.635H368.782V168.925H371.073V166.635Z",
    fill: "#F0F0F0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 170.48H368.782V172.771H371.073V170.48Z",
    fill: "#F0F0F0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 174.326H368.782V176.616H371.073V174.326Z",
    fill: "#F0F0F0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 178.162H368.782V180.453H371.073V178.162Z",
    fill: "#F0F0F0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 182.007H368.782V184.298H371.073V182.007Z",
    fill: "#F0F0F0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 185.853H368.782V188.144H371.073V185.853Z",
    fill: "#F0F0F0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 189.698H368.782V191.989H371.073V189.698Z",
    fill: "#F0F0F0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 193.544H368.782V195.835H371.073V193.544Z",
    fill: "#F0F0F0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 197.389H368.782V199.68H371.073V197.389Z",
    fill: "#F0F0F0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 201.235H368.782V203.526H371.073V201.235Z",
    fill: "#F0F0F0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 205.08H368.782V207.371H371.073V205.08Z",
    fill: "#F0F0F0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 208.926H368.782V211.217H371.073V208.926Z",
    fill: "#F0F0F0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 212.771H368.782V215.062H371.073V212.771Z",
    fill: "#F0F0F0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 216.608H368.782V218.898H371.073V216.608Z",
    fill: "#F0F0F0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M371.073 220.453H368.782V222.744H371.073V220.453Z",
    fill: "#F0F0F0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 155.098H365.139V157.389H367.43V155.098Z",
    fill: "#F0F0F0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 158.944H365.139V161.234H367.43V158.944Z",
    fill: "#F0F0F0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 162.789H365.139V165.08H367.43V162.789Z",
    fill: "#F0F0F0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 166.635H365.139V168.925H367.43V166.635Z",
    fill: "#F0F0F0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 170.48H365.139V172.771H367.43V170.48Z",
    fill: "#F0F0F0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 174.326H365.139V176.616H367.43V174.326Z",
    fill: "#F0F0F0"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 178.162H365.139V180.453H367.43V178.162Z",
    fill: "#F0F0F0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 182.007H365.139V184.298H367.43V182.007Z",
    fill: "#F0F0F0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 185.853H365.139V188.144H367.43V185.853Z",
    fill: "#F0F0F0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 189.698H365.139V191.989H367.43V189.698Z",
    fill: "#F0F0F0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 201.235H365.139V203.526H367.43V201.235Z",
    fill: "#F0F0F0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 205.08H365.139V207.371H367.43V205.08Z",
    fill: "#F0F0F0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 208.926H365.139V211.217H367.43V208.926Z",
    fill: "#F0F0F0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M367.43 212.771H365.139V215.062H367.43V212.771Z",
    fill: "#F0F0F0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 155.098H361.505V157.389H363.796V155.098Z",
    fill: "#F0F0F0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 158.944H361.505V161.234H363.796V158.944Z",
    fill: "#F0F0F0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 162.789H361.505V165.08H363.796V162.789Z",
    fill: "#F0F0F0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 166.635H361.505V168.925H363.796V166.635Z",
    fill: "#F0F0F0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 170.48H361.505V172.771H363.796V170.48Z",
    fill: "#F0F0F0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 174.326H361.505V176.616H363.796V174.326Z",
    fill: "#F0F0F0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 178.162H361.505V180.453H363.796V178.162Z",
    fill: "#F0F0F0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 182.007H361.505V184.298H363.796V182.007Z",
    fill: "#F0F0F0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 185.853H361.505V188.144H363.796V185.853Z",
    fill: "#F0F0F0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 189.698H361.505V191.989H363.796V189.698Z",
    fill: "#F0F0F0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 201.235H361.505V203.526H363.796V201.235Z",
    fill: "#F0F0F0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 205.08H361.505V207.371H363.796V205.08Z",
    fill: "#F0F0F0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M363.796 208.926H361.505V211.217H363.796V208.926Z",
    fill: "#F0F0F0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M322.782 145.116H320.491V147.407H322.782V145.116Z",
    fill: "#F0F0F0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M322.782 148.962H320.491V151.253H322.782V148.962Z",
    fill: "#F0F0F0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M322.782 152.807H320.491V155.098H322.782V152.807Z",
    fill: "#F0F0F0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M322.782 156.653H320.491V158.944H322.782V156.653Z",
    fill: "#F0F0F0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M322.782 160.498H320.491V162.789H322.782V160.498Z",
    fill: "#F0F0F0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M322.782 164.344H320.491V166.635H322.782V164.344Z",
    fill: "#F0F0F0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M322.782 168.18H320.491V170.471H322.782V168.18Z",
    fill: "#F0F0F0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M322.782 172.026H320.491V174.317H322.782V172.026Z",
    fill: "#F0F0F0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M322.782 183.562H320.491V185.853H322.782V183.562Z",
    fill: "#F0F0F0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M322.782 187.408H320.491V189.698H322.782V187.408Z",
    fill: "#F0F0F0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M319.139 145.116H316.848V147.407H319.139V145.116Z",
    fill: "#F0F0F0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M319.139 148.962H316.848V151.253H319.139V148.962Z",
    fill: "#F0F0F0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M319.139 152.807H316.848V155.098H319.139V152.807Z",
    fill: "#F0F0F0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M319.139 156.653H316.848V158.944H319.139V156.653Z",
    fill: "#F0F0F0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M319.139 160.498H316.848V162.789H319.139V160.498Z",
    fill: "#F0F0F0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M319.139 164.344H316.848V166.635H319.139V164.344Z",
    fill: "#F0F0F0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M319.139 168.18H316.848V170.471H319.139V168.18Z",
    fill: "#F0F0F0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M319.139 172.026H316.848V174.317H319.139V172.026Z",
    fill: "#F0F0F0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M319.139 187.408H316.848V189.698H319.139V187.408Z",
    fill: "#F0F0F0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M315.496 145.116H313.205V147.407H315.496V145.116Z",
    fill: "#F0F0F0"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M315.496 148.962H313.205V151.253H315.496V148.962Z",
    fill: "#F0F0F0"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M315.496 152.807H313.205V155.098H315.496V152.807Z",
    fill: "#F0F0F0"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M315.496 156.653H313.205V158.944H315.496V156.653Z",
    fill: "#F0F0F0"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M315.496 160.498H313.205V162.789H315.496V160.498Z",
    fill: "#F0F0F0"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M315.496 164.344H313.205V166.635H315.496V164.344Z",
    fill: "#F0F0F0"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M315.496 168.18H313.205V170.471H315.496V168.18Z",
    fill: "#F0F0F0"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M315.496 172.026H313.205V174.317H315.496V172.026Z",
    fill: "#F0F0F0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 145.116H309.562V147.407H311.852V145.116Z",
    fill: "#F0F0F0"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 148.962H309.562V151.253H311.852V148.962Z",
    fill: "#F0F0F0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 152.807H309.562V155.098H311.852V152.807Z",
    fill: "#F0F0F0"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 156.653H309.562V158.944H311.852V156.653Z",
    fill: "#F0F0F0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 160.498H309.562V162.789H311.852V160.498Z",
    fill: "#F0F0F0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 164.344H309.562V166.635H311.852V164.344Z",
    fill: "#F0F0F0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 172.026H309.562V174.317H311.852V172.026Z",
    fill: "#F0F0F0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 175.871H309.562V178.162H311.852V175.871Z",
    fill: "#F0F0F0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 187.408H309.562V189.698H311.852V187.408Z",
    fill: "#F0F0F0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 191.253H309.562V193.544H311.852V191.253Z",
    fill: "#F0F0F0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 195.099H309.562V197.389H311.852V195.099Z",
    fill: "#F0F0F0"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 198.944H309.562V201.235H311.852V198.944Z",
    fill: "#F0F0F0"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 202.789H309.562V205.08H311.852V202.789Z",
    fill: "#F0F0F0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 206.626H309.562V208.917H311.852V206.626Z",
    fill: "#F0F0F0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M311.852 210.471H309.562V212.762H311.852V210.471Z",
    fill: "#F0F0F0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 145.116H305.918V147.407H308.209V145.116Z",
    fill: "#F0F0F0"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 148.962H305.918V151.253H308.209V148.962Z",
    fill: "#F0F0F0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 152.807H305.918V155.098H308.209V152.807Z",
    fill: "#F0F0F0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 156.653H305.918V158.944H308.209V156.653Z",
    fill: "#F0F0F0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 160.498H305.918V162.789H308.209V160.498Z",
    fill: "#F0F0F0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 164.344H305.918V166.635H308.209V164.344Z",
    fill: "#F0F0F0"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 175.871H305.918V178.162H308.209V175.871Z",
    fill: "#F0F0F0"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 179.717H305.918V182.007H308.209V179.717Z",
    fill: "#F0F0F0"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 183.562H305.918V185.853H308.209V183.562Z",
    fill: "#F0F0F0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 187.408H305.918V189.698H308.209V187.408Z",
    fill: "#F0F0F0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 191.253H305.918V193.544H308.209V191.253Z",
    fill: "#F0F0F0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 195.099H305.918V197.389H308.209V195.099Z",
    fill: "#F0F0F0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 198.944H305.918V201.235H308.209V198.944Z",
    fill: "#F0F0F0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 202.789H305.918V205.08H308.209V202.789Z",
    fill: "#F0F0F0"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 206.626H305.918V208.917H308.209V206.626Z",
    fill: "#F0F0F0"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 210.471H305.918V212.762H308.209V210.471Z",
    fill: "#F0F0F0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 214.317H305.918V216.608H308.209V214.317Z",
    fill: "#F0F0F0"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M308.209 222.008H305.918V224.299H308.209V222.008Z",
    fill: "#F0F0F0"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 145.116H302.275V147.407H304.566V145.116Z",
    fill: "#F0F0F0"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 148.962H302.275V151.253H304.566V148.962Z",
    fill: "#F0F0F0"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 152.807H302.275V155.098H304.566V152.807Z",
    fill: "#F0F0F0"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 156.653H302.275V158.944H304.566V156.653Z",
    fill: "#F0F0F0"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 160.498H302.275V162.789H304.566V160.498Z",
    fill: "#F0F0F0"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 164.344H302.275V166.635H304.566V164.344Z",
    fill: "#F0F0F0"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 175.871H302.275V178.162H304.566V175.871Z",
    fill: "#F0F0F0"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 179.717H302.275V182.007H304.566V179.717Z",
    fill: "#F0F0F0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 183.562H302.275V185.853H304.566V183.562Z",
    fill: "#F0F0F0"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 187.408H302.275V189.698H304.566V187.408Z",
    fill: "#F0F0F0"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 198.944H302.275V201.235H304.566V198.944Z",
    fill: "#F0F0F0"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 202.789H302.275V205.08H304.566V202.789Z",
    fill: "#F0F0F0"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 206.626H302.275V208.917H304.566V206.626Z",
    fill: "#F0F0F0"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 210.471H302.275V212.762H304.566V210.471Z",
    fill: "#F0F0F0"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 214.317H302.275V216.608H304.566V214.317Z",
    fill: "#F0F0F0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 222.008H302.275V224.299H304.566V222.008Z",
    fill: "#F0F0F0"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M304.566 225.853H302.275V228.144H304.566V225.853Z",
    fill: "#F0F0F0"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M271.52 180.867H269.229V183.157H271.52V180.867Z",
    fill: "#F0F0F0"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M271.52 184.712H269.229V187.003H271.52V184.712Z",
    fill: "#F0F0F0"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M271.52 188.558H269.229V190.848H271.52V188.558Z",
    fill: "#F0F0F0"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M271.52 192.394H269.229V194.685H271.52V192.394Z",
    fill: "#F0F0F0"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M271.52 196.24H269.229V198.53H271.52V196.24Z",
    fill: "#F0F0F0"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M271.52 200.085H269.229V202.376H271.52V200.085Z",
    fill: "#F0F0F0"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M271.52 203.93H269.229V206.221H271.52V203.93Z",
    fill: "#F0F0F0"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M271.52 215.467H269.229V217.758H271.52V215.467Z",
    fill: "#F0F0F0"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M271.52 219.312H269.229V221.603H271.52V219.312Z",
    fill: "#F0F0F0"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M271.52 223.158H269.229V225.449H271.52V223.158Z",
    fill: "#F0F0F0"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M267.876 180.867H265.585V183.157H267.876V180.867Z",
    fill: "#F0F0F0"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M267.876 184.712H265.585V187.003H267.876V184.712Z",
    fill: "#F0F0F0"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M267.876 188.558H265.585V190.848H267.876V188.558Z",
    fill: "#F0F0F0"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M267.876 192.394H265.585V194.685H267.876V192.394Z",
    fill: "#F0F0F0"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M267.876 196.24H265.585V198.53H267.876V196.24Z",
    fill: "#F0F0F0"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M267.876 200.085H265.585V202.376H267.876V200.085Z",
    fill: "#F0F0F0"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M267.876 203.93H265.585V206.221H267.876V203.93Z",
    fill: "#F0F0F0"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M264.233 180.867H261.943V183.157H264.233V180.867Z",
    fill: "#F0F0F0"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M264.233 184.712H261.943V187.003H264.233V184.712Z",
    fill: "#F0F0F0"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M264.233 188.558H261.943V190.848H264.233V188.558Z",
    fill: "#F0F0F0"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M264.233 192.394H261.943V194.685H264.233V192.394Z",
    fill: "#F0F0F0"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M264.233 196.24H261.943V198.53H264.233V196.24Z",
    fill: "#F0F0F0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M264.233 200.085H261.943V202.376H264.233V200.085Z",
    fill: "#F0F0F0"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M264.233 203.93H261.943V206.221H264.233V203.93Z",
    fill: "#F0F0F0"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59 180.867H258.299V183.157H260.59V180.867Z",
    fill: "#F0F0F0"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59 184.712H258.299V187.003H260.59V184.712Z",
    fill: "#F0F0F0"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59 188.558H258.299V190.848H260.59V188.558Z",
    fill: "#F0F0F0"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59 192.394H258.299V194.685H260.59V192.394Z",
    fill: "#F0F0F0"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59 196.24H258.299V198.53H260.59V196.24Z",
    fill: "#F0F0F0"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59 200.085H258.299V202.376H260.59V200.085Z",
    fill: "#F0F0F0"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59 203.93H258.299V206.221H260.59V203.93Z",
    fill: "#F0F0F0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59 207.776H258.299V210.067H260.59V207.776Z",
    fill: "#F0F0F0"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59 211.621H258.299V213.912H260.59V211.621Z",
    fill: "#F0F0F0"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59 215.467H258.299V217.758H260.59V215.467Z",
    fill: "#F0F0F0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59 219.312H258.299V221.603H260.59V219.312Z",
    fill: "#F0F0F0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 180.867H254.656V183.157H256.947V180.867Z",
    fill: "#F0F0F0"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 184.712H254.656V187.003H256.947V184.712Z",
    fill: "#F0F0F0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 188.558H254.656V190.848H256.947V188.558Z",
    fill: "#F0F0F0"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 192.394H254.656V194.685H256.947V192.394Z",
    fill: "#F0F0F0"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 196.24H254.656V198.53H256.947V196.24Z",
    fill: "#F0F0F0"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 200.085H254.656V202.376H256.947V200.085Z",
    fill: "#F0F0F0"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 203.93H254.656V206.221H256.947V203.93Z",
    fill: "#F0F0F0"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 207.776H254.656V210.067H256.947V207.776Z",
    fill: "#F0F0F0"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 211.621H254.656V213.912H256.947V211.621Z",
    fill: "#F0F0F0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 215.467H254.656V217.758H256.947V215.467Z",
    fill: "#F0F0F0"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 219.312H254.656V221.603H256.947V219.312Z",
    fill: "#F0F0F0"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 223.158H254.656V225.449H256.947V223.158Z",
    fill: "#F0F0F0"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 234.685H254.656V236.976H256.947V234.685Z",
    fill: "#F0F0F0"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M256.947 238.531H254.656V240.821H256.947V238.531Z",
    fill: "#F0F0F0"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 180.867H251.013V183.157H253.304V180.867Z",
    fill: "#F0F0F0"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 184.712H251.013V187.003H253.304V184.712Z",
    fill: "#F0F0F0"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 188.558H251.013V190.848H253.304V188.558Z",
    fill: "#F0F0F0"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 200.085H251.013V202.376H253.304V200.085Z",
    fill: "#F0F0F0"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 203.93H251.013V206.221H253.304V203.93Z",
    fill: "#F0F0F0"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 207.776H251.013V210.067H253.304V207.776Z",
    fill: "#F0F0F0"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 211.621H251.013V213.912H253.304V211.621Z",
    fill: "#F0F0F0"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 215.467H251.013V217.758H253.304V215.467Z",
    fill: "#F0F0F0"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 219.312H251.013V221.603H253.304V219.312Z",
    fill: "#F0F0F0"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 223.158H251.013V225.449H253.304V223.158Z",
    fill: "#F0F0F0"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 234.685H251.013V236.976H253.304V234.685Z",
    fill: "#F0F0F0"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 238.531H251.013V240.821H253.304V238.531Z",
    fill: "#F0F0F0"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M253.304 242.376H251.013V244.667H253.304V242.376Z",
    fill: "#F0F0F0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 157.794H212.842V160.084H215.133V157.794Z",
    fill: "#F0F0F0"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 161.639H212.842V163.93H215.133V161.639Z",
    fill: "#F0F0F0"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 165.485H212.842V167.775H215.133V165.485Z",
    fill: "#F0F0F0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 169.33H212.842V171.621H215.133V169.33Z",
    fill: "#F0F0F0"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 173.176H212.842V175.466H215.133V173.176Z",
    fill: "#F0F0F0"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 177.021H212.842V179.312H215.133V177.021Z",
    fill: "#F0F0F0"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 180.867H212.842V183.157H215.133V180.867Z",
    fill: "#F0F0F0"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 184.712H212.842V187.003H215.133V184.712Z",
    fill: "#F0F0F0"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 188.558H212.842V190.848H215.133V188.558Z",
    fill: "#F0F0F0"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 192.394H212.842V194.685H215.133V192.394Z",
    fill: "#F0F0F0"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 196.24H212.842V198.53H215.133V196.24Z",
    fill: "#F0F0F0"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 200.085H212.842V202.376H215.133V200.085Z",
    fill: "#F0F0F0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 203.93H212.842V206.221H215.133V203.93Z",
    fill: "#F0F0F0"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 207.776H212.842V210.067H215.133V207.776Z",
    fill: "#F0F0F0"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 211.621H212.842V213.912H215.133V211.621Z",
    fill: "#F0F0F0"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 215.467H212.842V217.758H215.133V215.467Z",
    fill: "#F0F0F0"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 219.312H212.842V221.603H215.133V219.312Z",
    fill: "#F0F0F0"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 223.158H212.842V225.449H215.133V223.158Z",
    fill: "#F0F0F0"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 227.003H212.842V229.294H215.133V227.003Z",
    fill: "#F0F0F0"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 230.84H212.842V233.13H215.133V230.84Z",
    fill: "#F0F0F0"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 234.685H212.842V236.976H215.133V234.685Z",
    fill: "#F0F0F0"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 238.531H212.842V240.821H215.133V238.531Z",
    fill: "#F0F0F0"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M215.133 242.376H212.842V244.667H215.133V242.376Z",
    fill: "#F0F0F0"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 157.794H209.199V160.084H211.49V157.794Z",
    fill: "#F0F0F0"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 161.639H209.199V163.93H211.49V161.639Z",
    fill: "#F0F0F0"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 165.485H209.199V167.775H211.49V165.485Z",
    fill: "#F0F0F0"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 169.33H209.199V171.621H211.49V169.33Z",
    fill: "#F0F0F0"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 173.176H209.199V175.466H211.49V173.176Z",
    fill: "#F0F0F0"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 177.021H209.199V179.312H211.49V177.021Z",
    fill: "#F0F0F0"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 180.867H209.199V183.157H211.49V180.867Z",
    fill: "#F0F0F0"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 184.712H209.199V187.003H211.49V184.712Z",
    fill: "#F0F0F0"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 188.558H209.199V190.848H211.49V188.558Z",
    fill: "#F0F0F0"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 192.394H209.199V194.685H211.49V192.394Z",
    fill: "#F0F0F0"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 196.24H209.199V198.53H211.49V196.24Z",
    fill: "#F0F0F0"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 200.085H209.199V202.376H211.49V200.085Z",
    fill: "#F0F0F0"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 203.93H209.199V206.221H211.49V203.93Z",
    fill: "#F0F0F0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 207.776H209.199V210.067H211.49V207.776Z",
    fill: "#F0F0F0"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 211.621H209.199V213.912H211.49V211.621Z",
    fill: "#F0F0F0"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 215.467H209.199V217.758H211.49V215.467Z",
    fill: "#F0F0F0"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 219.312H209.199V221.603H211.49V219.312Z",
    fill: "#F0F0F0"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 223.158H209.199V225.449H211.49V223.158Z",
    fill: "#F0F0F0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M211.49 227.003H209.199V229.294H211.49V227.003Z",
    fill: "#F0F0F0"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 157.794H205.556V160.084H207.846V157.794Z",
    fill: "#F0F0F0"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 161.639H205.556V163.93H207.846V161.639Z",
    fill: "#F0F0F0"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 165.485H205.556V167.775H207.846V165.485Z",
    fill: "#F0F0F0"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 169.33H205.556V171.621H207.846V169.33Z",
    fill: "#F0F0F0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 173.176H205.556V175.466H207.846V173.176Z",
    fill: "#F0F0F0"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 177.021H205.556V179.312H207.846V177.021Z",
    fill: "#F0F0F0"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 180.867H205.556V183.157H207.846V180.867Z",
    fill: "#F0F0F0"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 184.712H205.556V187.003H207.846V184.712Z",
    fill: "#F0F0F0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 188.558H205.556V190.848H207.846V188.558Z",
    fill: "#F0F0F0"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 192.394H205.556V194.685H207.846V192.394Z",
    fill: "#F0F0F0"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 196.24H205.556V198.53H207.846V196.24Z",
    fill: "#F0F0F0"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 200.085H205.556V202.376H207.846V200.085Z",
    fill: "#F0F0F0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 203.93H205.556V206.221H207.846V203.93Z",
    fill: "#F0F0F0"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 207.776H205.556V210.067H207.846V207.776Z",
    fill: "#F0F0F0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 211.621H205.556V213.912H207.846V211.621Z",
    fill: "#F0F0F0"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 215.467H205.556V217.758H207.846V215.467Z",
    fill: "#F0F0F0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 219.312H205.556V221.603H207.846V219.312Z",
    fill: "#F0F0F0"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 223.158H205.556V225.449H207.846V223.158Z",
    fill: "#F0F0F0"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M207.846 227.003H205.556V229.294H207.846V227.003Z",
    fill: "#F0F0F0"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 157.794H201.912V160.084H204.203V157.794Z",
    fill: "#F0F0F0"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 161.639H201.912V163.93H204.203V161.639Z",
    fill: "#F0F0F0"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 165.485H201.912V167.775H204.203V165.485Z",
    fill: "#F0F0F0"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 169.33H201.912V171.621H204.203V169.33Z",
    fill: "#F0F0F0"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 173.176H201.912V175.466H204.203V173.176Z",
    fill: "#F0F0F0"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 177.021H201.912V179.312H204.203V177.021Z",
    fill: "#F0F0F0"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 180.867H201.912V183.157H204.203V180.867Z",
    fill: "#F0F0F0"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 184.712H201.912V187.003H204.203V184.712Z",
    fill: "#F0F0F0"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 188.558H201.912V190.848H204.203V188.558Z",
    fill: "#F0F0F0"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 192.394H201.912V194.685H204.203V192.394Z",
    fill: "#F0F0F0"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 196.24H201.912V198.53H204.203V196.24Z",
    fill: "#F0F0F0"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 200.085H201.912V202.376H204.203V200.085Z",
    fill: "#F0F0F0"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 203.93H201.912V206.221H204.203V203.93Z",
    fill: "#F0F0F0"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 207.776H201.912V210.067H204.203V207.776Z",
    fill: "#F0F0F0"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M204.203 211.621H201.912V213.912H204.203V211.621Z",
    fill: "#F0F0F0"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 157.794H198.269V160.084H200.56V157.794Z",
    fill: "#F0F0F0"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 161.639H198.269V163.93H200.56V161.639Z",
    fill: "#F0F0F0"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 165.485H198.269V167.775H200.56V165.485Z",
    fill: "#F0F0F0"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 169.33H198.269V171.621H200.56V169.33Z",
    fill: "#F0F0F0"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 173.176H198.269V175.466H200.56V173.176Z",
    fill: "#F0F0F0"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 177.021H198.269V179.312H200.56V177.021Z",
    fill: "#F0F0F0"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 180.867H198.269V183.157H200.56V180.867Z",
    fill: "#F0F0F0"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 184.712H198.269V187.003H200.56V184.712Z",
    fill: "#F0F0F0"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 188.558H198.269V190.848H200.56V188.558Z",
    fill: "#F0F0F0"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 192.394H198.269V194.685H200.56V192.394Z",
    fill: "#F0F0F0"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 196.24H198.269V198.53H200.56V196.24Z",
    fill: "#F0F0F0"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 200.085H198.269V202.376H200.56V200.085Z",
    fill: "#F0F0F0"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 203.93H198.269V206.221H200.56V203.93Z",
    fill: "#F0F0F0"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 157.794H194.626V160.084H196.917V157.794Z",
    fill: "#F0F0F0"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 161.639H194.626V163.93H196.917V161.639Z",
    fill: "#F0F0F0"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 165.485H194.626V167.775H196.917V165.485Z",
    fill: "#F0F0F0"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 169.33H194.626V171.621H196.917V169.33Z",
    fill: "#F0F0F0"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 173.176H194.626V175.466H196.917V173.176Z",
    fill: "#F0F0F0"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 177.021H194.626V179.312H196.917V177.021Z",
    fill: "#F0F0F0"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 180.867H194.626V183.157H196.917V180.867Z",
    fill: "#F0F0F0"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 184.712H194.626V187.003H196.917V184.712Z",
    fill: "#F0F0F0"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 188.558H194.626V190.848H196.917V188.558Z",
    fill: "#F0F0F0"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 192.394H194.626V194.685H196.917V192.394Z",
    fill: "#F0F0F0"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 196.24H194.626V198.53H196.917V196.24Z",
    fill: "#F0F0F0"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M196.917 200.085H194.626V202.376H196.917V200.085Z",
    fill: "#F0F0F0"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 156.653H407.229V158.944H409.52V156.653Z",
    fill: "#F0F0F0"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 160.498H407.229V162.789H409.52V160.498Z",
    fill: "#F0F0F0"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 164.344H407.229V166.635H409.52V164.344Z",
    fill: "#F0F0F0"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 168.18H407.229V170.471H409.52V168.18Z",
    fill: "#F0F0F0"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 172.026H407.229V174.317H409.52V172.026Z",
    fill: "#F0F0F0"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 175.871H407.229V178.162H409.52V175.871Z",
    fill: "#F0F0F0"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 179.717H407.229V182.007H409.52V179.717Z",
    fill: "#F0F0F0"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 183.562H407.229V185.853H409.52V183.562Z",
    fill: "#F0F0F0"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 187.408H407.229V189.698H409.52V187.408Z",
    fill: "#F0F0F0"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 191.253H407.229V193.544H409.52V191.253Z",
    fill: "#F0F0F0"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 195.099H407.229V197.389H409.52V195.099Z",
    fill: "#F0F0F0"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 198.944H407.229V201.235H409.52V198.944Z",
    fill: "#F0F0F0"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 202.789H407.229V205.08H409.52V202.789Z",
    fill: "#F0F0F0"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 206.626H407.229V208.917H409.52V206.626Z",
    fill: "#F0F0F0"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 210.471H407.229V212.762H409.52V210.471Z",
    fill: "#F0F0F0"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 214.317H407.229V216.608H409.52V214.317Z",
    fill: "#F0F0F0"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 218.162H407.229V220.453H409.52V218.162Z",
    fill: "#F0F0F0"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 225.853H407.229V228.144H409.52V225.853Z",
    fill: "#F0F0F0"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 229.699H407.229V231.99H409.52V229.699Z",
    fill: "#F0F0F0"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 233.544H407.229V235.835H409.52V233.544Z",
    fill: "#F0F0F0"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 237.39H407.229V239.681H409.52V237.39Z",
    fill: "#F0F0F0"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M409.52 241.226H407.229V243.517H409.52V241.226Z",
    fill: "#F0F0F0"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 156.653H403.585V158.944H405.876V156.653Z",
    fill: "#F0F0F0"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 160.498H403.585V162.789H405.876V160.498Z",
    fill: "#F0F0F0"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 164.344H403.585V166.635H405.876V164.344Z",
    fill: "#F0F0F0"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 168.18H403.585V170.471H405.876V168.18Z",
    fill: "#F0F0F0"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 172.026H403.585V174.317H405.876V172.026Z",
    fill: "#F0F0F0"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 175.871H403.585V178.162H405.876V175.871Z",
    fill: "#F0F0F0"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 179.717H403.585V182.007H405.876V179.717Z",
    fill: "#F0F0F0"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 183.562H403.585V185.853H405.876V183.562Z",
    fill: "#F0F0F0"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 187.408H403.585V189.698H405.876V187.408Z",
    fill: "#F0F0F0"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 191.253H403.585V193.544H405.876V191.253Z",
    fill: "#F0F0F0"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 195.099H403.585V197.389H405.876V195.099Z",
    fill: "#F0F0F0"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 198.944H403.585V201.235H405.876V198.944Z",
    fill: "#F0F0F0"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 202.789H403.585V205.08H405.876V202.789Z",
    fill: "#F0F0F0"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 206.626H403.585V208.917H405.876V206.626Z",
    fill: "#F0F0F0"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 210.471H403.585V212.762H405.876V210.471Z",
    fill: "#F0F0F0"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 214.317H403.585V216.608H405.876V214.317Z",
    fill: "#F0F0F0"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 237.39H403.585V239.681H405.876V237.39Z",
    fill: "#F0F0F0"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M405.876 241.226H403.585V243.517H405.876V241.226Z",
    fill: "#F0F0F0"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 156.653H399.952V158.944H402.242V156.653Z",
    fill: "#F0F0F0"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 160.498H399.952V162.789H402.242V160.498Z",
    fill: "#F0F0F0"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 164.344H399.952V166.635H402.242V164.344Z",
    fill: "#F0F0F0"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 168.18H399.952V170.471H402.242V168.18Z",
    fill: "#F0F0F0"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 172.026H399.952V174.317H402.242V172.026Z",
    fill: "#F0F0F0"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 175.871H399.952V178.162H402.242V175.871Z",
    fill: "#F0F0F0"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 179.717H399.952V182.007H402.242V179.717Z",
    fill: "#F0F0F0"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 183.562H399.952V185.853H402.242V183.562Z",
    fill: "#F0F0F0"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 187.408H399.952V189.698H402.242V187.408Z",
    fill: "#F0F0F0"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 191.253H399.952V193.544H402.242V191.253Z",
    fill: "#F0F0F0"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 195.099H399.952V197.389H402.242V195.099Z",
    fill: "#F0F0F0"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 198.944H399.952V201.235H402.242V198.944Z",
    fill: "#F0F0F0"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 202.789H399.952V205.08H402.242V202.789Z",
    fill: "#F0F0F0"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 206.626H399.952V208.917H402.242V206.626Z",
    fill: "#F0F0F0"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 210.471H399.952V212.762H402.242V210.471Z",
    fill: "#F0F0F0"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 214.317H399.952V216.608H402.242V214.317Z",
    fill: "#F0F0F0"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 222.008H399.952V224.299H402.242V222.008Z",
    fill: "#F0F0F0"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 225.853H399.952V228.144H402.242V225.853Z",
    fill: "#F0F0F0"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 229.699H399.952V231.99H402.242V229.699Z",
    fill: "#F0F0F0"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 233.544H399.952V235.835H402.242V233.544Z",
    fill: "#F0F0F0"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M402.242 241.226H399.952V243.517H402.242V241.226Z",
    fill: "#F0F0F0"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 183.562H336.407V185.853H338.698V183.562Z",
    fill: "#F0F0F0"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 187.408H336.407V189.698H338.698V187.408Z",
    fill: "#F0F0F0"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 191.253H336.407V193.544H338.698V191.253Z",
    fill: "#F0F0F0"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 195.099H336.407V197.389H338.698V195.099Z",
    fill: "#F0F0F0"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 198.944H336.407V201.235H338.698V198.944Z",
    fill: "#F0F0F0"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 202.789H336.407V205.08H338.698V202.789Z",
    fill: "#F0F0F0"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 206.626H336.407V208.917H338.698V206.626Z",
    fill: "#F0F0F0"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 210.471H336.407V212.762H338.698V210.471Z",
    fill: "#F0F0F0"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 214.317H336.407V216.608H338.698V214.317Z",
    fill: "#F0F0F0"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 218.162H336.407V220.453H338.698V218.162Z",
    fill: "#F0F0F0"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 222.008H336.407V224.299H338.698V222.008Z",
    fill: "#F0F0F0"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 225.853H336.407V228.144H338.698V225.853Z",
    fill: "#F0F0F0"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 229.699H336.407V231.99H338.698V229.699Z",
    fill: "#F0F0F0"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 237.39H336.407V239.681H338.698V237.39Z",
    fill: "#F0F0F0"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 241.226H336.407V243.517H338.698V241.226Z",
    fill: "#F0F0F0"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 245.072H336.407V247.362H338.698V245.072Z",
    fill: "#F0F0F0"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 248.917H336.407V251.208H338.698V248.917Z",
    fill: "#F0F0F0"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 256.608H336.407V258.899H338.698V256.608Z",
    fill: "#F0F0F0"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 260.453H336.407V262.744H338.698V260.453Z",
    fill: "#F0F0F0"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M338.698 264.299H336.407V266.59H338.698V264.299Z",
    fill: "#F0F0F0"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 183.562H332.764V185.853H335.055V183.562Z",
    fill: "#F0F0F0"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 187.408H332.764V189.698H335.055V187.408Z",
    fill: "#F0F0F0"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 191.253H332.764V193.544H335.055V191.253Z",
    fill: "#F0F0F0"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 195.099H332.764V197.389H335.055V195.099Z",
    fill: "#F0F0F0"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 198.944H332.764V201.235H335.055V198.944Z",
    fill: "#F0F0F0"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 202.789H332.764V205.08H335.055V202.789Z",
    fill: "#F0F0F0"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 206.626H332.764V208.917H335.055V206.626Z",
    fill: "#F0F0F0"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 210.471H332.764V212.762H335.055V210.471Z",
    fill: "#F0F0F0"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 214.317H332.764V216.608H335.055V214.317Z",
    fill: "#F0F0F0"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 218.162H332.764V220.453H335.055V218.162Z",
    fill: "#F0F0F0"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 222.008H332.764V224.299H335.055V222.008Z",
    fill: "#F0F0F0"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 225.853H332.764V228.144H335.055V225.853Z",
    fill: "#F0F0F0"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 229.699H332.764V231.99H335.055V229.699Z",
    fill: "#F0F0F0"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 241.226H332.764V243.517H335.055V241.226Z",
    fill: "#F0F0F0"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 245.072H332.764V247.362H335.055V245.072Z",
    fill: "#F0F0F0"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 252.763H332.764V255.053H335.055V252.763Z",
    fill: "#F0F0F0"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 256.608H332.764V258.899H335.055V256.608Z",
    fill: "#F0F0F0"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 260.453H332.764V262.744H335.055V260.453Z",
    fill: "#F0F0F0"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M335.055 264.299H332.764V266.59H335.055V264.299Z",
    fill: "#F0F0F0"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 183.562H329.121V185.853H331.412V183.562Z",
    fill: "#F0F0F0"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 187.408H329.121V189.698H331.412V187.408Z",
    fill: "#F0F0F0"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 191.253H329.121V193.544H331.412V191.253Z",
    fill: "#F0F0F0"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 195.099H329.121V197.389H331.412V195.099Z",
    fill: "#F0F0F0"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 198.944H329.121V201.235H331.412V198.944Z",
    fill: "#F0F0F0"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 202.789H329.121V205.08H331.412V202.789Z",
    fill: "#F0F0F0"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 206.626H329.121V208.917H331.412V206.626Z",
    fill: "#F0F0F0"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 210.471H329.121V212.762H331.412V210.471Z",
    fill: "#F0F0F0"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 214.317H329.121V216.608H331.412V214.317Z",
    fill: "#F0F0F0"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 218.162H329.121V220.453H331.412V218.162Z",
    fill: "#F0F0F0"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 222.008H329.121V224.299H331.412V222.008Z",
    fill: "#F0F0F0"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 225.853H329.121V228.144H331.412V225.853Z",
    fill: "#F0F0F0"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 229.699H329.121V231.99H331.412V229.699Z",
    fill: "#F0F0F0"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 233.544H329.121V235.835H331.412V233.544Z",
    fill: "#F0F0F0"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 241.226H329.121V243.517H331.412V241.226Z",
    fill: "#F0F0F0"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 248.917H329.121V251.208H331.412V248.917Z",
    fill: "#F0F0F0"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 252.763H329.121V255.053H331.412V252.763Z",
    fill: "#F0F0F0"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 256.608H329.121V258.899H331.412V256.608Z",
    fill: "#F0F0F0"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 260.453H329.121V262.744H331.412V260.453Z",
    fill: "#F0F0F0"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M331.412 264.299H329.121V266.59H331.412V264.299Z",
    fill: "#F0F0F0"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 205.485H351.247V207.776H353.538V205.485Z",
    fill: "#F0F0F0"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 209.331H351.247V211.621H353.538V209.331Z",
    fill: "#F0F0F0"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 213.176H351.247V215.467H353.538V213.176Z",
    fill: "#F0F0F0"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 217.012H351.247V219.303H353.538V217.012Z",
    fill: "#F0F0F0"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 220.858H351.247V223.149H353.538V220.858Z",
    fill: "#F0F0F0"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 224.703H351.247V226.994H353.538V224.703Z",
    fill: "#F0F0F0"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 236.24H351.247V238.531H353.538V236.24Z",
    fill: "#F0F0F0"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 240.085H351.247V242.376H353.538V240.085Z",
    fill: "#F0F0F0"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 243.931H351.247V246.222H353.538V243.931Z",
    fill: "#F0F0F0"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 247.776H351.247V250.067H353.538V247.776Z",
    fill: "#F0F0F0"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 251.622H351.247V253.913H353.538V251.622Z",
    fill: "#F0F0F0"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 255.458H351.247V257.749H353.538V255.458Z",
    fill: "#F0F0F0"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M353.538 259.304H351.247V261.594H353.538V259.304Z",
    fill: "#F0F0F0"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 205.485H347.604V207.776H349.895V205.485Z",
    fill: "#F0F0F0"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 209.331H347.604V211.621H349.895V209.331Z",
    fill: "#F0F0F0"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 213.176H347.604V215.467H349.895V213.176Z",
    fill: "#F0F0F0"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 217.012H347.604V219.303H349.895V217.012Z",
    fill: "#F0F0F0"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 220.858H347.604V223.149H349.895V220.858Z",
    fill: "#F0F0F0"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 224.703H347.604V226.994H349.895V224.703Z",
    fill: "#F0F0F0"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 236.24H347.604V238.531H349.895V236.24Z",
    fill: "#F0F0F0"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 240.085H347.604V242.376H349.895V240.085Z",
    fill: "#F0F0F0"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 243.931H347.604V246.222H349.895V243.931Z",
    fill: "#F0F0F0"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 247.776H347.604V250.067H349.895V247.776Z",
    fill: "#F0F0F0"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 251.622H347.604V253.913H349.895V251.622Z",
    fill: "#F0F0F0"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 255.458H347.604V257.749H349.895V255.458Z",
    fill: "#F0F0F0"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M349.895 263.149H347.604V265.44H349.895V263.149Z",
    fill: "#F0F0F0"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 188.558H226.596V190.848H228.887V188.558Z",
    fill: "#F0F0F0"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 192.394H226.596V194.685H228.887V192.394Z",
    fill: "#F0F0F0"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 196.24H226.596V198.53H228.887V196.24Z",
    fill: "#F0F0F0"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 200.085H226.596V202.376H228.887V200.085Z",
    fill: "#F0F0F0"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 203.93H226.596V206.221H228.887V203.93Z",
    fill: "#F0F0F0"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 207.776H226.596V210.067H228.887V207.776Z",
    fill: "#F0F0F0"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 211.621H226.596V213.912H228.887V211.621Z",
    fill: "#F0F0F0"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 215.467H226.596V217.758H228.887V215.467Z",
    fill: "#F0F0F0"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 219.312H226.596V221.603H228.887V219.312Z",
    fill: "#F0F0F0"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 223.158H226.596V225.449H228.887V223.158Z",
    fill: "#F0F0F0"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 227.003H226.596V229.294H228.887V227.003Z",
    fill: "#F0F0F0"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 234.685H226.596V236.976H228.887V234.685Z",
    fill: "#F0F0F0"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 238.531H226.596V240.821H228.887V238.531Z",
    fill: "#F0F0F0"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 242.376H226.596V244.667H228.887V242.376Z",
    fill: "#F0F0F0"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 246.222H226.596V248.512H228.887V246.222Z",
    fill: "#F0F0F0"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 250.067H226.596V252.358H228.887V250.067Z",
    fill: "#F0F0F0"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 253.912H226.596V256.203H228.887V253.912Z",
    fill: "#F0F0F0"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 257.758H226.596V260.049H228.887V257.758Z",
    fill: "#F0F0F0"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M228.887 261.603H226.596V263.894H228.887V261.603Z",
    fill: "#F0F0F0"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 188.558H222.962V190.848H225.253V188.558Z",
    fill: "#F0F0F0"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 192.394H222.962V194.685H225.253V192.394Z",
    fill: "#F0F0F0"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 196.24H222.962V198.53H225.253V196.24Z",
    fill: "#F0F0F0"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 200.085H222.962V202.376H225.253V200.085Z",
    fill: "#F0F0F0"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 203.93H222.962V206.221H225.253V203.93Z",
    fill: "#F0F0F0"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 207.776H222.962V210.067H225.253V207.776Z",
    fill: "#F0F0F0"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 211.621H222.962V213.912H225.253V211.621Z",
    fill: "#F0F0F0"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 215.467H222.962V217.758H225.253V215.467Z",
    fill: "#F0F0F0"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 219.312H222.962V221.603H225.253V219.312Z",
    fill: "#F0F0F0"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 223.158H222.962V225.449H225.253V223.158Z",
    fill: "#F0F0F0"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 227.003H222.962V229.294H225.253V227.003Z",
    fill: "#F0F0F0"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 230.84H222.962V233.13H225.253V230.84Z",
    fill: "#F0F0F0"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 234.685H222.962V236.976H225.253V234.685Z",
    fill: "#F0F0F0"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 238.531H222.962V240.821H225.253V238.531Z",
    fill: "#F0F0F0"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 242.376H222.962V244.667H225.253V242.376Z",
    fill: "#F0F0F0"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 246.222H222.962V248.512H225.253V246.222Z",
    fill: "#F0F0F0"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 250.067H222.962V252.358H225.253V250.067Z",
    fill: "#F0F0F0"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 253.912H222.962V256.203H225.253V253.912Z",
    fill: "#F0F0F0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 257.758H222.962V260.049H225.253V257.758Z",
    fill: "#F0F0F0"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M225.253 261.603H222.962V263.894H225.253V261.603Z",
    fill: "#F0F0F0"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M246.836 203.526H244.545V205.816H246.836V203.526Z",
    fill: "#F0F0F0"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M246.836 207.371H244.545V209.662H246.836V207.371Z",
    fill: "#F0F0F0"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M246.836 211.216H244.545V213.507H246.836V211.216Z",
    fill: "#F0F0F0"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M246.836 215.062H244.545V217.353H246.836V215.062Z",
    fill: "#F0F0F0"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M246.836 218.907H244.545V221.198H246.836V218.907Z",
    fill: "#F0F0F0"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M246.836 222.753H244.545V225.044H246.836V222.753Z",
    fill: "#F0F0F0"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M246.836 226.598H244.545V228.889H246.836V226.598Z",
    fill: "#F0F0F0"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M246.836 230.435H244.545V232.726H246.836V230.435Z",
    fill: "#F0F0F0"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M246.836 234.28H244.545V236.571H246.836V234.28Z",
    fill: "#F0F0F0"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M246.836 238.126H244.545V240.417H246.836V238.126Z",
    fill: "#F0F0F0"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M243.193 203.526H240.902V205.816H243.193V203.526Z",
    fill: "#F0F0F0"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M243.193 207.371H240.902V209.662H243.193V207.371Z",
    fill: "#F0F0F0"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M243.193 211.216H240.902V213.507H243.193V211.216Z",
    fill: "#F0F0F0"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M243.193 215.062H240.902V217.353H243.193V215.062Z",
    fill: "#F0F0F0"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M243.193 218.907H240.902V221.198H243.193V218.907Z",
    fill: "#F0F0F0"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M243.193 222.753H240.902V225.044H243.193V222.753Z",
    fill: "#F0F0F0"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M243.193 226.598H240.902V228.889H243.193V226.598Z",
    fill: "#F0F0F0"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M243.193 230.435H240.902V232.726H243.193V230.435Z",
    fill: "#F0F0F0"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M243.193 234.28H240.902V236.571H243.193V234.28Z",
    fill: "#F0F0F0"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M264.859 57.6271H261.013V272.054H264.859V57.6271Z",
    fill: "#E0E0E0"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M337.272 57.6271H333.426V272.054H337.272V57.6271Z",
    fill: "#E0E0E0"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M409.676 57.6271H405.831V272.054H409.676V57.6271Z",
    fill: "#E0E0E0"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M135.994 251.153H159.712C160.788 251.153 161.82 251.58 162.581 252.341C163.342 253.102 163.769 254.134 163.769 255.21V301.052H131.946V255.246C131.942 254.711 132.043 254.181 132.244 253.685C132.445 253.189 132.742 252.738 133.118 252.357C133.495 251.977 133.943 251.674 134.436 251.467C134.93 251.261 135.459 251.154 135.994 251.153Z",
    fill: "#F0F0F0"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M163.769 257.942H131.946V261.521H163.769V257.942Z",
    fill: "#E6E6E6"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M150.043 295.044H157.973C158.551 295.044 159.106 295.274 159.515 295.683C159.924 296.092 160.153 296.647 160.153 297.225V301.089H147.853V297.225C147.853 296.938 147.91 296.653 148.02 296.388C148.13 296.123 148.291 295.882 148.495 295.68C148.698 295.477 148.94 295.317 149.205 295.208C149.471 295.099 149.756 295.043 150.043 295.044Z",
    fill: "#E0E0E0"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M160.19 301.089H151.377C151.001 301.089 150.641 300.939 150.375 300.674C150.109 300.408 149.96 300.048 149.96 299.672C149.962 299.298 150.113 298.94 150.378 298.676C150.644 298.412 151.003 298.264 151.377 298.264H160.19C160.565 298.264 160.924 298.412 161.189 298.676C161.454 298.94 161.605 299.298 161.607 299.672C161.607 300.048 161.458 300.408 161.192 300.674C160.926 300.939 160.566 301.089 160.19 301.089Z",
    fill: "#E6E6E6"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M301.496 47.5668C313.142 44.8183 320.355 33.1496 317.606 21.5041C314.858 9.8586 303.188 2.64625 291.543 5.39483C279.897 8.14342 272.684 19.8121 275.433 31.4576C278.182 43.1031 289.851 50.3154 301.496 47.5668Z",
    fill: "#E0E0E0"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M299.467 44.6446C309.513 43.014 316.334 33.5486 314.704 23.5031C313.073 13.4576 303.607 6.63601 293.562 8.26663C283.516 9.89724 276.694 19.3626 278.325 29.4081C279.955 39.4536 289.421 46.2752 299.467 44.6446Z",
    fill: "#F0F0F0"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M297.39 13.8271V26.7071L305.918 21.8771",
    fill: "#F0F0F0"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M297.39 27.5996C297.225 27.5996 297.063 27.5551 296.921 27.4708C296.783 27.3894 296.67 27.2736 296.591 27.1349C296.512 26.9962 296.47 26.8393 296.47 26.6796V13.7996C296.47 13.5556 296.567 13.3216 296.739 13.1491C296.912 12.9766 297.146 12.8796 297.39 12.8796C297.634 12.8796 297.868 12.9766 298.04 13.1491C298.213 13.3216 298.31 13.5556 298.31 13.7996V25.1248L305.468 21.0768C305.68 20.9577 305.931 20.9275 306.165 20.9931C306.4 21.0586 306.599 21.2144 306.719 21.4264C306.839 21.6377 306.87 21.8878 306.806 22.1222C306.743 22.3566 306.589 22.5563 306.378 22.6776L297.841 27.5076C297.7 27.5728 297.545 27.6043 297.39 27.5996Z",
    fill: "#E0E0E0"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1753 237.942C87.5193 235.182 84.7961 237.583 84.7961 237.583C85.1825 232.358 80.3801 228.788 80.3801 228.788C80.3801 228.788 85.9645 228.788 86.7373 223.461C87.5101 218.135 84.7961 220.609 82.2385 220.573C79.6809 220.536 77.0037 228.006 80.3985 232.21C83.7933 236.415 82.8641 243.59 75.0717 250.49C73.2083 252.234 71.8104 254.416 71.0053 256.838C71.5941 250.499 71.9253 241.566 70.0853 235.605C66.9205 225.485 72.9557 222.725 74.6853 217.684C76.4149 212.642 70.0853 208.337 70.0853 208.337C70.0853 208.337 76.0745 205.577 73.1489 202.495C70.2233 199.413 64.1881 199.8 64.1881 203.875C64.1881 207.951 68.2821 209.505 68.2821 209.505C68.2821 209.505 72.9557 214.372 72.9557 216.865C72.9557 219.358 68.2821 224.851 68.2821 224.851C68.2821 224.851 70.4257 220.186 66.1385 219.993C61.8513 219.8 60.4897 225.439 62.2469 227.969C64.0041 230.499 66.9205 228.365 66.9205 228.365C67.1035 231.318 67.5499 234.249 68.2545 237.123C68.6961 238.586 68.4937 244.299 68.1257 250.242C67.3121 248.096 66.0114 246.169 64.3261 244.612C56.5337 237.712 55.6321 230.536 59.0085 226.332C62.3849 222.127 59.7077 214.657 57.1685 214.694C54.6293 214.731 51.8785 212.247 52.6605 217.574C53.4425 222.9 59.0269 222.909 59.0269 222.909C59.0269 222.909 54.2153 226.479 54.6017 231.704C54.6017 231.704 51.8417 229.331 50.2225 232.063C47.2693 236.93 54.1233 239.947 55.2733 237.583C55.2733 237.583 69.8001 247.868 66.3133 262.671L67.1229 263.876C67.0217 265.072 66.9573 265.789 66.9573 265.789L68.0889 265.302L69.3861 267.206C69.3408 269.358 69.4514 271.51 69.7173 273.646L73.1857 268.512C69.6805 253.71 84.2257 243.425 84.2257 243.425C85.2837 245.835 92.1285 242.808 89.1753 237.942Z",
    fill: "#E0E0E0"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1753 237.942C87.5193 235.182 84.7961 237.583 84.7961 237.583C85.1825 232.358 80.3801 228.788 80.3801 228.788C80.3801 228.788 85.9645 228.788 86.7373 223.461C87.5101 218.135 84.7961 220.609 82.2385 220.573C79.6809 220.536 77.0037 228.006 80.3985 232.21C83.7933 236.415 82.8641 243.59 75.0717 250.49C73.2083 252.234 71.8104 254.416 71.0053 256.838C71.5941 250.499 71.9253 241.566 70.0853 235.605C66.9205 225.485 72.9557 222.725 74.6853 217.684C76.4149 212.642 70.0853 208.337 70.0853 208.337C70.0853 208.337 76.0745 205.577 73.1489 202.495C70.2233 199.413 64.1881 199.8 64.1881 203.875C64.1881 207.951 68.2821 209.505 68.2821 209.505C68.2821 209.505 72.9557 214.372 72.9557 216.865C72.9557 219.358 68.2821 224.851 68.2821 224.851C68.2821 224.851 70.4257 220.186 66.1385 219.993C61.8513 219.8 60.4897 225.439 62.2469 227.969C64.0041 230.499 66.9205 228.365 66.9205 228.365C67.1035 231.318 67.5499 234.249 68.2545 237.123C68.6961 238.586 68.4937 244.299 68.1257 250.242C67.3121 248.096 66.0114 246.169 64.3261 244.612C56.5337 237.712 55.6321 230.536 59.0085 226.332C62.3849 222.127 59.7077 214.657 57.1685 214.694C54.6293 214.731 51.8785 212.247 52.6605 217.574C53.4425 222.9 59.0269 222.909 59.0269 222.909C59.0269 222.909 54.2153 226.479 54.6017 231.704C54.6017 231.704 51.8417 229.331 50.2225 232.063C47.2693 236.93 54.1233 239.947 55.2733 237.583C55.2733 237.583 69.8001 247.868 66.3133 262.671L67.1229 263.876C67.0217 265.072 66.9573 265.789 66.9573 265.789L68.0889 265.302L69.3861 267.206C69.3408 269.358 69.4514 271.51 69.7173 273.646L73.1857 268.512C69.6805 253.71 84.2257 243.425 84.2257 243.425C85.2837 245.835 92.1285 242.808 89.1753 237.942Z",
    fill: "#407BFF"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3329 301.089H53.0565L49.4685 264.658H89.9301L86.3329 301.089Z",
    fill: "#A0BDFF"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6964 260.637H47.6836V268.678H91.6964V260.637Z",
    fill: "#6695FF"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M230 342.746C328.516 342.746 408.378 338.083 408.378 332.331C408.378 326.58 328.516 321.917 230 321.917C131.484 321.917 51.6208 326.58 51.6208 332.331C51.6208 338.083 131.484 342.746 230 342.746Z",
    fill: "#F5F5F5"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M377.614 303.333C377.752 302.413 380.972 280.178 374.523 272.505C373.881 271.697 373.068 271.04 372.142 270.584C371.216 270.127 370.201 269.882 369.168 269.865C356.141 269.561 354.366 279.984 354.347 280.122L355.884 280.362C355.939 279.984 357.484 271.162 369.132 271.42C369.943 271.431 370.742 271.624 371.469 271.983C372.196 272.343 372.834 272.861 373.336 273.499C379.334 280.647 376.096 302.873 376.096 303.103L377.614 303.333Z",
    fill: "#407BFF"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M378.396 302.322L379.951 302.267C379.951 302.065 379.436 281.797 389.418 277.611C399.206 273.517 403.613 281.944 403.788 282.303L405.177 281.604C405.131 281.503 399.961 271.484 388.82 276.185C377.853 280.776 378.368 301.439 378.396 302.322Z",
    fill: "#407BFF"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M378.35 303.913C378.35 303.591 378.451 271.539 384.698 262.165C390.696 253.158 400.338 257.399 400.789 257.565L401.424 256.148C401.313 256.102 390.144 251.171 383.401 261.282C376.896 271.042 376.804 302.552 376.804 303.895L378.35 303.913Z",
    fill: "#407BFF"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M367.301 270.638C367.301 270.638 372.986 272.735 371.294 277.676C369.601 282.616 351.633 290.767 351.633 290.767C351.633 290.767 344.098 283.867 351.017 272.643C357.935 261.419 367.144 267.096 367.301 270.638Z",
    fill: "#407BFF"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M384.974 260.472C384.974 260.472 380.944 260.04 381.294 257.583C381.643 255.127 396.989 248.797 406.051 259.028C406.051 259.028 400.246 269 391.855 269.148C383.465 269.295 384.974 260.472 384.974 260.472Z",
    fill: "#407BFF"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M389.16 276.912C389.16 276.912 386.4 274.667 389.381 273.572C392.361 272.478 407.137 272.781 407.284 287.372C407.284 287.372 390.107 290.234 387.964 284.668C385.82 279.102 389.16 276.912 389.16 276.912Z",
    fill: "#407BFF"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M367.301 270.638C367.301 270.638 372.986 272.735 371.294 277.676C369.601 282.616 351.633 290.767 351.633 290.767C351.633 290.767 344.098 283.867 351.017 272.643C357.935 261.419 367.144 267.096 367.301 270.638Z",
    fill: "black"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M384.974 260.472C384.974 260.472 380.944 260.04 381.294 257.583C381.643 255.127 396.989 248.797 406.051 259.028C406.051 259.028 400.246 269 391.855 269.148C383.465 269.295 384.974 260.472 384.974 260.472Z",
    fill: "black"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M389.16 276.912C389.16 276.912 386.4 274.667 389.381 273.572C392.361 272.478 407.137 272.781 407.284 287.372C407.284 287.372 390.107 290.234 387.964 284.668C385.82 279.102 389.16 276.912 389.16 276.912Z",
    fill: "black"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M364.246 333.095H390.908L393.778 303.913H361.376L364.246 333.095Z",
    fill: "#407BFF"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.246 333.095H390.908L393.778 303.913H361.376L364.246 333.095Z",
    fill: "white"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M359.95 307.124H395.204V300.684H359.95V307.124Z",
    fill: "#407BFF"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M359.95 307.124H395.204V300.684H359.95V307.124Z",
    fill: "white"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M334.07 312.174L307.565 309.571V272.312H297.059V309.552L270.48 312.174C269.205 312.3 268.023 312.895 267.163 313.844C266.302 314.792 265.825 316.027 265.825 317.308V321.291H338.762V317.308C338.763 316.021 338.282 314.78 337.413 313.83C336.545 312.88 335.352 312.289 334.07 312.174Z",
    fill: "#263238"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.07 312.174L307.565 309.571V272.312H297.059V309.552L270.48 312.174C269.205 312.3 268.023 312.895 267.163 313.844C266.302 314.792 265.825 316.027 265.825 317.308V321.291H338.762V317.308C338.763 316.021 338.282 314.78 337.413 313.83C336.545 312.88 335.352 312.289 334.07 312.174Z",
    fill: "white"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M268.594 333.104C272.39 333.104 275.466 330.027 275.466 326.232C275.466 322.436 272.39 319.359 268.594 319.359C264.799 319.359 261.722 322.436 261.722 326.232C261.722 330.027 264.799 333.104 268.594 333.104Z",
    fill: "#263238"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M335.929 333.104C339.724 333.104 342.801 330.027 342.801 326.232C342.801 322.436 339.724 319.359 335.929 319.359C332.133 319.359 329.056 322.436 329.056 326.232C329.056 330.027 332.133 333.104 335.929 333.104Z",
    fill: "#263238"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M295.255 247.141H309.377V276.516C309.377 277.524 308.977 278.49 308.264 279.203C307.552 279.915 306.585 280.316 305.578 280.316H299.055C298.047 280.316 297.081 279.915 296.368 279.203C295.656 278.49 295.255 277.524 295.255 276.516V247.141Z",
    fill: "#263238"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M295.255 247.141H309.377V276.516C309.377 277.524 308.977 278.49 308.264 279.203C307.552 279.915 306.585 280.316 305.578 280.316H299.055C298.047 280.316 297.081 279.915 296.368 279.203C295.656 278.49 295.255 277.524 295.255 276.516V247.141Z",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M327.428 188.917C327.428 188.917 329.434 238.595 315.597 247.142H331.393C331.393 247.142 343.629 230.223 340.17 188.917H327.428Z",
    fill: "#263238"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.428 188.917C327.428 188.917 329.434 238.595 315.597 247.142H331.393C331.393 247.142 343.629 230.223 340.17 188.917H327.428Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M336.766 250.95H266V244.795C266 243.575 266.484 242.405 267.347 241.543C268.21 240.68 269.38 240.195 270.6 240.195H332.166C333.386 240.195 334.556 240.68 335.419 241.543C336.281 242.405 336.766 243.575 336.766 244.795V250.95Z",
    fill: "#263238"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M264.896 250.95H337.861C338.882 250.95 339.71 250.122 339.71 249.101V247.427C339.71 246.405 338.882 245.577 337.861 245.577H264.896C263.874 245.577 263.046 246.405 263.046 247.427V249.101C263.046 250.122 263.874 250.95 264.896 250.95Z",
    fill: "#263238"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M264.896 250.95H337.861C338.882 250.95 339.71 250.122 339.71 249.101V247.427C339.71 246.405 338.882 245.577 337.861 245.577H264.896C263.874 245.577 263.046 246.405 263.046 247.427V249.101C263.046 250.122 263.874 250.95 264.896 250.95Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M344.043 162.283H318.743C311.335 162.283 305.33 168.289 305.33 175.696V185.595C305.33 193.003 311.335 199.009 318.743 199.009H344.043C351.451 199.009 357.457 193.003 357.457 185.595V175.696C357.457 168.289 351.451 162.283 344.043 162.283Z",
    fill: "#263238"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M242.006 121.695L236.955 108.382C236.955 108.382 239.126 106.377 237.636 104.344C236.146 102.31 226.835 96.5972 225.143 97.6C223.45 98.6028 219.669 102.393 221.711 104.5C223.753 106.607 232.751 110.112 232.751 110.112L237.222 127.592L242.006 121.695Z",
    fill: "#E4897B"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M277.269 147.002C277.269 147.002 254.269 142.283 251.813 141.151C249.357 140.02 240.12 112.945 240.12 112.945L233.027 116.257C233.027 116.257 238.731 143.433 244.563 149.891C250.396 156.349 275.291 161.851 275.291 161.851L277.269 147.002Z",
    fill: "#407BFF"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M275.237 161.823L274.813 161.722C273.562 161.437 269.634 160.517 264.969 159.146C257.398 156.947 247.848 153.626 244.518 149.9C238.694 143.461 232.981 116.257 232.981 116.257L240.065 112.945C240.065 112.945 249.311 140.029 251.813 141.151C254.316 142.274 277.27 147.002 277.27 147.002L275.237 161.823Z",
    fill: "black"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M240.184 112.411L241.647 115.236L232.539 118.373L232.889 114.923L240.184 112.411Z",
    fill: "#407BFF"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M275.411 161.446C274.142 161.262 270.158 160.646 265.393 159.606C268.107 154.914 276.055 152.504 276.055 152.504L275.411 161.446Z",
    fill: "black"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M309.654 128.254C309.654 128.254 311.006 140.977 306.296 144.105C301.585 147.233 278.392 143.572 275.761 138.447C273.13 133.323 283.029 119.431 283.029 119.431L309.654 128.254Z",
    fill: "#263238"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M215.823 295.671L221.876 297.133L224.94 288.78L227.718 281.181L220.828 278.246L218.178 287.464L215.823 295.671Z",
    fill: "#E4897B"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M218.178 287.464L224.94 288.78L227.718 281.181L220.827 278.246L218.178 287.464Z",
    fill: "black"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M218.785 283.057L227.175 286.176C227.175 286.176 249.559 230.214 254.159 230.058C258.759 229.901 305.596 251.392 317.335 239.45C329.075 227.509 312.101 198.714 312.101 198.714C312.101 198.714 283.866 194.685 281.741 201.06C281.217 202.939 280.818 204.851 280.545 206.782C280.223 208.733 280.002 210.37 280.002 210.37C279.128 210.149 250.783 202.836 239.614 210.37C228.252 218.034 218.785 283.057 218.785 283.057Z",
    fill: "#407BFF"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M218.785 283.057L227.175 286.176C227.175 286.176 249.559 230.214 254.159 230.058C258.759 229.901 305.596 251.392 317.335 239.45C329.075 227.509 312.101 198.714 312.101 198.714C312.101 198.714 283.866 194.685 281.741 201.06C281.217 202.939 280.818 204.851 280.545 206.782C280.223 208.733 280.002 210.37 280.002 210.37C279.128 210.149 250.783 202.836 239.614 210.37C228.252 218.034 218.785 283.057 218.785 283.057Z",
    fill: "white"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M267.049 319.544L273.075 318.008L271.915 309.35L270.839 301.42L263.387 302.092L265.319 311.338L267.049 319.544Z",
    fill: "#E4897B"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M265.365 311.521L271.952 309.516L270.857 301.503L263.396 302.137L265.365 311.521Z",
    fill: "black"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M230.644 283.067L218.417 278.917L217.893 283.922L227.166 287.197L230.644 283.067Z",
    fill: "#407BFF"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M297.059 242.284C297.059 242.284 295.145 242.33 265.53 240.95C265.53 240.95 269.955 277.97 272.375 305.689L263.515 307.197C263.515 307.197 242.355 247.85 242.585 238.42C242.815 228.99 253.625 226.231 253.625 226.231C253.625 226.231 274.721 238.42 297.059 242.284Z",
    fill: "#407BFF"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M297.059 242.284C297.059 242.284 295.145 242.33 265.53 240.95C265.53 240.95 269.955 277.97 272.375 305.689L263.515 307.197C263.515 307.197 242.355 247.85 242.585 238.42C242.815 228.99 253.625 226.231 253.625 226.231C253.625 226.231 274.721 238.42 297.059 242.284Z",
    fill: "white"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M297.059 242.284C297.059 242.284 295.145 242.33 265.53 240.95C265.53 240.95 269.955 277.97 272.375 305.689L263.515 307.197C263.515 307.197 242.355 247.85 242.585 238.42C242.815 228.99 253.625 226.231 253.625 226.231C253.625 226.231 274.721 238.42 297.059 242.284Z",
    fill: "black"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M273.663 303.002L261.491 304.391L263.847 309.157L273.7 307.897L273.663 303.002Z",
    fill: "#407BFF"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M280.002 210.37L296.516 213.811C296.516 213.811 287.389 208.769 280.545 206.782C280.223 208.733 280.002 210.37 280.002 210.37Z",
    fill: "black"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M311.42 194.326L312.101 198.714L281.741 201.06L280.94 195.862L311.42 194.326Z",
    fill: "#263238"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M311.42 194.326L312.101 198.714L281.741 201.06L280.94 195.862L311.42 194.326Z",
    fill: "black"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M301.844 201.678L303.345 201.524L302.56 193.882L301.059 194.036L301.844 201.678Z",
    fill: "#407BFF"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M288.357 200.915L295.004 200.487L294.679 195.447L288.032 195.874L288.357 200.915Z",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M283.217 202.481L284.718 202.327L283.932 194.685L282.431 194.839L283.217 202.481Z",
    fill: "#407BFF"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M301.844 201.678L303.345 201.524L302.56 193.882L301.059 194.036L301.844 201.678Z",
    fill: "white"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M283.217 202.481L284.718 202.327L283.932 194.685L282.431 194.839L283.217 202.481Z",
    fill: "white"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M276.717 146.588C282.404 148.159 288.305 148.808 294.197 148.511C303.949 148.014 315.56 152.715 315.56 152.715L311.383 194.298L280.894 195.835C280.894 195.835 270.691 161.142 276.717 146.588Z",
    fill: "#407BFF"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M281.621 123.102C281.621 123.102 283.332 102.917 300.205 110.222C321.365 119.422 304.547 144.022 294.197 138.98C283.847 133.939 281.621 123.102 281.621 123.102Z",
    fill: "#263238"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M286.35 149.643L286.838 161.051L290.619 155.687C290.619 155.687 289.266 168.3 290.058 175.173C290.058 175.173 290.784 162.854 292.496 155.687L296.516 161.051L302.285 149.716C302.285 149.716 292.946 146.358 286.35 149.643Z",
    fill: "black"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M291.576 151.796L300.307 149.33C294.925 145.65 297.638 137.37 297.638 137.37L288.991 140.406C289.388 141.608 289.696 142.839 289.911 144.086C290.831 149.478 288.383 149.91 288.383 149.91L291.576 151.796Z",
    fill: "#E4897B"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.99 140.36C289.388 141.562 289.696 142.792 289.91 144.04C294.05 142.375 297.629 137.306 297.629 137.306L288.99 140.36Z",
    fill: "black"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M294.639 114.491C286.975 112.798 283.599 116.331 281.299 124.114C278.419 133.82 279.054 141.309 289.091 141.327C302.726 141.345 307.353 117.306 294.639 114.491Z",
    fill: "#E4897B"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M286.341 124.785C285.478 125.793 284.496 126.692 283.415 127.462C283.569 127.831 283.823 128.149 284.148 128.381C284.473 128.614 284.856 128.751 285.255 128.778L286.341 124.785Z",
    fill: "#DE5753"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M291.17 125.19C291.014 125.815 291.226 126.413 291.649 126.515C292.072 126.616 292.523 126.193 292.679 125.595C292.836 124.997 292.624 124.38 292.201 124.27C291.778 124.159 291.327 124.564 291.17 125.19Z",
    fill: "#263238"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M292.367 124.316L291.143 123.451C291.143 123.451 291.539 124.767 292.367 124.316Z",
    fill: "#263238"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M283.424 123.148C283.268 123.773 283.479 124.371 283.903 124.472C284.326 124.574 284.823 124.15 284.933 123.552C285.043 122.954 284.878 122.338 284.455 122.228C284.031 122.117 283.581 122.522 283.424 123.148Z",
    fill: "#263238"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M284.62 122.274L283.36 121.436C283.36 121.436 283.792 122.715 284.62 122.274Z",
    fill: "#263238"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M295.485 122.145C295.424 122.146 295.363 122.13 295.309 122.1C295.256 122.069 295.212 122.024 295.182 121.97C294.879 121.497 294.473 121.098 293.996 120.801C293.518 120.505 292.98 120.32 292.422 120.259C292.334 120.247 292.254 120.203 292.197 120.135C292.141 120.066 292.113 119.979 292.118 119.891C292.127 119.802 292.171 119.721 292.24 119.664C292.309 119.607 292.397 119.58 292.486 119.587C293.164 119.653 293.818 119.875 294.396 120.236C294.974 120.596 295.46 121.086 295.817 121.667C295.837 121.706 295.849 121.749 295.853 121.793C295.857 121.837 295.852 121.881 295.838 121.923C295.824 121.965 295.802 122.004 295.773 122.037C295.744 122.071 295.709 122.098 295.669 122.117C295.611 122.14 295.548 122.15 295.485 122.145Z",
    fill: "#263238"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M286.92 118.677C286.858 118.675 286.797 118.656 286.745 118.621C286.293 118.404 285.798 118.292 285.297 118.292C284.795 118.292 284.3 118.404 283.848 118.621C283.808 118.638 283.765 118.646 283.722 118.645C283.679 118.645 283.637 118.636 283.597 118.619C283.558 118.601 283.522 118.577 283.492 118.545C283.463 118.514 283.44 118.478 283.424 118.437C283.408 118.397 283.4 118.354 283.4 118.31C283.4 118.266 283.409 118.223 283.426 118.183C283.443 118.143 283.468 118.106 283.5 118.076C283.531 118.045 283.568 118.021 283.608 118.005C284.158 117.749 284.759 117.623 285.365 117.636C285.971 117.648 286.566 117.8 287.104 118.079C287.141 118.102 287.173 118.132 287.199 118.168C287.224 118.204 287.242 118.245 287.251 118.287C287.26 118.33 287.261 118.374 287.253 118.417C287.246 118.461 287.229 118.502 287.205 118.539C287.173 118.583 287.13 118.619 287.08 118.643C287.03 118.667 286.975 118.678 286.92 118.677Z",
    fill: "#263238"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M300.15 129.248C300.15 129.248 297.96 122.164 299.579 117.426C299.579 117.426 285.779 107.867 281.621 123.102C281.621 123.102 283.157 109.1 296.396 111.712C309.635 114.325 305.302 133.562 297.233 137.794C297.233 137.794 301.493 133.673 300.15 129.248Z",
    fill: "#263238"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M298.54 130.636C298.809 129.766 299.413 129.038 300.218 128.612C301.024 128.186 301.965 128.096 302.836 128.364C305.155 129.146 305.201 134.27 299.046 134.132C298.154 134.068 297.859 133.139 298.54 130.636Z",
    fill: "#E4897B"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M283.866 131.685C284.07 132.624 284.206 133.578 284.271 134.537H284.767C287.058 134.73 288.181 134.059 288.733 133.267C288.996 132.874 289.161 132.423 289.211 131.952C289.25 131.686 289.25 131.417 289.211 131.151C287.734 131.66 286.165 131.845 284.611 131.694C284.169 131.722 283.866 131.685 283.866 131.685Z",
    fill: "#263238"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M284.648 131.74L284.786 132.577C286.939 132.752 288.466 132.577 289.211 131.998C289.25 131.732 289.25 131.463 289.211 131.197C287.746 131.701 286.19 131.886 284.648 131.74Z",
    fill: "white"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M284.767 134.583C287.058 134.776 288.181 134.104 288.733 133.313C287.864 133.257 286.992 133.353 286.157 133.598C285.601 133.772 285.115 134.117 284.767 134.583Z",
    fill: "#DE5753"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M294.667 115.107C294.667 115.107 294.961 128.383 302.947 129.984C310.932 131.584 302.211 112.908 302.211 112.908C302.211 112.908 290.343 105.162 282.431 110.627C274.519 116.092 281.639 123.102 281.639 123.102C281.639 123.102 283.286 113.24 294.667 115.107Z",
    fill: "#263238"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M297.712 127.26C297.658 127.26 297.606 127.24 297.565 127.205C291.898 122.752 294.695 114.233 294.722 114.15C294.743 114.093 294.785 114.045 294.84 114.018C294.895 113.991 294.958 113.985 295.017 114.003C295.074 114.024 295.121 114.066 295.147 114.122C295.172 114.177 295.175 114.24 295.155 114.297C295.155 114.38 292.441 122.577 297.85 126.846C297.872 126.867 297.89 126.892 297.902 126.92C297.914 126.947 297.92 126.977 297.92 127.007C297.92 127.037 297.914 127.067 297.902 127.095C297.89 127.123 297.872 127.148 297.85 127.168C297.835 127.192 297.815 127.213 297.791 127.229C297.767 127.245 297.74 127.256 297.712 127.26Z",
    fill: "#263238"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M305.256 132.706C304.244 135.411 301.64 136.929 299.441 136.11C297.243 135.291 296.286 132.43 297.298 129.725C298.31 127.021 300.913 125.503 303.112 126.331C305.311 127.159 306.268 130.011 305.256 132.706Z",
    fill: "#407BFF"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M305.256 132.706C304.244 135.411 301.64 136.929 299.441 136.11C297.243 135.291 296.286 132.43 297.298 129.725C298.31 127.021 300.913 125.503 303.112 126.331C305.311 127.159 306.268 130.011 305.256 132.706Z",
    fill: "black"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M302.68 128.282C302.68 128.282 305.983 113.497 298.577 109.624C299.42 109.734 300.256 109.897 301.079 110.112C301.999 110.388 307.951 116.386 304.961 129.671L302.68 128.282Z",
    fill: "#407BFF"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M302.68 128.282C302.68 128.282 305.983 113.497 298.577 109.624C299.42 109.734 300.256 109.897 301.079 110.112C301.999 110.388 307.951 116.386 304.961 129.671L302.68 128.282Z",
    fill: "black"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M288.88 136.745L288.328 136.662L288.475 135.742C292.538 136.367 296.69 135.487 300.15 133.267L300.693 134.003C297.213 136.309 293.019 137.282 288.88 136.745Z",
    fill: "#407BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.88 136.745L288.328 136.662L288.475 135.742C292.538 136.367 296.69 135.487 300.15 133.267L300.693 134.003C297.213 136.309 293.019 137.282 288.88 136.745Z",
    fill: "black"
  }))), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M304.943 132.338C304.281 134.123 302.551 135.098 301.107 134.583C299.662 134.068 299.018 132.154 299.69 130.369C300.361 128.585 302.082 127.609 303.526 128.125C304.971 128.64 305.615 130.553 304.943 132.338Z",
    fill: "#407BFF"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M288.015 137.076L287.27 136.975C287.14 136.958 287.014 136.915 286.901 136.85C286.787 136.784 286.688 136.696 286.608 136.592C286.529 136.488 286.471 136.369 286.437 136.242C286.404 136.115 286.396 135.982 286.414 135.852C286.43 135.721 286.472 135.595 286.537 135.48C286.602 135.366 286.69 135.265 286.794 135.185C286.899 135.104 287.018 135.045 287.146 135.012C287.273 134.978 287.406 134.97 287.537 134.988L288.273 135.089C288.535 135.125 288.773 135.264 288.934 135.473C289.096 135.683 289.169 135.948 289.137 136.211C289.101 136.474 288.963 136.711 288.753 136.873C288.543 137.035 288.278 137.107 288.015 137.076Z",
    fill: "#407BFF"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M288.015 137.076L287.27 136.975C287.14 136.958 287.014 136.915 286.901 136.85C286.787 136.784 286.688 136.696 286.608 136.592C286.529 136.488 286.471 136.369 286.437 136.242C286.404 136.115 286.396 135.982 286.414 135.852C286.43 135.721 286.472 135.595 286.537 135.48C286.602 135.366 286.69 135.265 286.794 135.185C286.899 135.104 287.018 135.045 287.146 135.012C287.273 134.978 287.406 134.97 287.537 134.988L288.273 135.089C288.535 135.125 288.773 135.264 288.934 135.473C289.096 135.683 289.169 135.948 289.137 136.211C289.101 136.474 288.963 136.711 288.753 136.873C288.543 137.035 288.278 137.107 288.015 137.076Z",
    fill: "black"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M297.96 146.138L292.495 151.501L294.685 158.088L302.284 149.716L297.96 146.138Z",
    fill: "#407BFF"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M290.058 147.26L290.941 151.391L288.117 157.233L286.35 149.643L290.058 147.26Z",
    fill: "#407BFF"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M296.792 150.793L299.965 139.174C299.965 139.174 298.429 136.285 298.76 135.678C299.091 135.071 300.747 127.269 301.925 126.423C303.103 125.576 307.951 127.021 308.439 127.812C308.926 128.603 303.793 139.174 303.793 139.174L301.953 151.769L296.792 150.793Z",
    fill: "#E4897B"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M315.56 152.715C324.3 161.658 306.792 181.915 296.755 181.051C286.718 180.186 297.013 143.461 297.013 143.461L303.453 144.518C303.453 144.518 301.199 160.416 301.907 161.658C302.616 162.9 312.662 149.744 315.56 152.715Z",
    fill: "#407BFF"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M315.56 152.715C324.3 161.658 306.792 181.915 296.755 181.051C286.718 180.186 297.013 143.461 297.013 143.461L303.453 144.518C303.453 144.518 301.199 160.416 301.907 161.658C302.616 162.9 312.662 149.744 315.56 152.715Z",
    fill: "black"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M296.516 142.311L295.568 145.347L304.52 146.138V143.488L296.516 142.311Z",
    fill: "#407BFF"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M282.946 166.331H279.321C278.919 166.331 278.594 166.657 278.594 167.058V173.903C278.594 174.304 278.919 174.63 279.321 174.63H282.946C283.347 174.63 283.672 174.304 283.672 173.903V167.058C283.672 166.657 283.347 166.331 282.946 166.331Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M283.02 166.883H278.898V172.523H283.02V166.883Z",
    fill: "black"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M281.511 164.335H280.6V167.656H281.511V164.335Z",
    fill: "#263238"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M205.813 307.428C206.731 307.001 207.72 306.748 208.729 306.682C208.729 306.682 212.225 304.631 215.685 296.636H219.576C220.236 296.641 220.878 296.849 221.415 297.233C221.952 297.617 222.357 298.157 222.575 298.78C222.64 298.95 222.678 299.131 222.686 299.313C222.64 300.254 222.538 301.191 222.382 302.119C221.813 305.229 221.054 308.302 220.11 311.319L219.447 311.154L220.643 305.339C221.048 303.37 218.969 305.275 218.012 307.262C217.055 309.249 215.574 311.264 211.269 310.28C206.255 309.047 204.24 308.329 205.813 307.428Z",
    fill: "#407BFF"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M216.393 294.548C216.393 294.548 211.526 304.723 208.729 306.683C208.729 306.683 212.483 308.918 216.393 303.923C221.444 297.483 222.686 299.277 222.686 299.277C222.58 298.165 222.374 297.066 222.069 295.992C221.315 293.931 216.393 294.548 216.393 294.548Z",
    fill: "#E4897B"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M259.375 331.669C260.17 331.042 261.071 330.563 262.034 330.252C262.034 330.252 264.941 327.428 266.404 318.844L270.185 317.924C270.827 317.776 271.499 317.829 272.11 318.076C272.72 318.323 273.24 318.752 273.599 319.304C273.702 319.457 273.783 319.625 273.838 319.801C274.022 320.712 274.148 321.634 274.215 322.561C274.392 325.705 274.377 328.858 274.169 332H273.488L273.277 326.075C273.194 324.061 271.639 326.407 271.17 328.569C270.701 330.731 269.753 333.021 265.337 333.086C260.194 333.141 258.06 332.92 259.375 331.669Z",
    fill: "#407BFF"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M266.598 316.645C266.598 316.645 264.288 327.685 261.998 330.252C261.998 330.252 266.174 331.54 268.787 325.772C272.173 318.32 273.801 319.773 273.801 319.773C273.437 318.719 272.979 317.7 272.43 316.728C271.234 314.888 266.598 316.645 266.598 316.645Z",
    fill: "#E4897B"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M352.139 93.9752H320.022C317.446 93.9752 315.358 96.0635 315.358 98.6396V112.375C315.358 114.951 317.446 117.04 320.022 117.04H352.139C354.715 117.04 356.804 114.951 356.804 112.375V98.6396C356.804 96.0635 354.715 93.9752 352.139 93.9752Z",
    fill: "#407BFF"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M326.462 114.408L316.784 127.564L332.396 115.291L326.462 114.408Z",
    fill: "#407BFF"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M326.821 105.502C326.823 105.773 326.744 106.037 326.595 106.262C326.447 106.488 326.234 106.664 325.985 106.768C325.736 106.872 325.461 106.9 325.196 106.848C324.931 106.795 324.688 106.665 324.497 106.474C324.306 106.283 324.176 106.04 324.124 105.775C324.071 105.51 324.099 105.235 324.203 104.986C324.307 104.737 324.483 104.525 324.709 104.376C324.934 104.227 325.199 104.148 325.469 104.15C325.827 104.15 326.171 104.293 326.425 104.546C326.679 104.8 326.821 105.144 326.821 105.502Z",
    fill: "white"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M333.896 105.502C333.897 105.773 333.819 106.037 333.67 106.262C333.521 106.488 333.308 106.664 333.059 106.768C332.81 106.872 332.536 106.9 332.271 106.848C332.006 106.795 331.762 106.665 331.571 106.474C331.38 106.283 331.25 106.04 331.198 105.775C331.146 105.51 331.174 105.235 331.278 104.986C331.382 104.737 331.558 104.525 331.783 104.376C332.009 104.227 332.273 104.148 332.543 104.15C332.902 104.15 333.246 104.293 333.499 104.546C333.753 104.8 333.896 105.144 333.896 105.502Z",
    fill: "white"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M340.97 105.502C340.972 105.773 340.894 106.037 340.745 106.262C340.596 106.488 340.383 106.664 340.134 106.768C339.885 106.872 339.61 106.9 339.346 106.848C339.081 106.795 338.837 106.665 338.646 106.474C338.455 106.283 338.325 106.04 338.273 105.775C338.221 105.51 338.249 105.235 338.353 104.986C338.457 104.737 338.633 104.525 338.858 104.376C339.083 104.227 339.348 104.148 339.618 104.15C339.977 104.15 340.321 104.293 340.574 104.546C340.828 104.8 340.97 105.144 340.97 105.502Z",
    fill: "white"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M348.045 105.502C348.047 105.773 347.969 106.037 347.82 106.262C347.671 106.488 347.458 106.664 347.209 106.768C346.96 106.872 346.685 106.9 346.42 106.848C346.155 106.795 345.912 106.665 345.721 106.474C345.53 106.283 345.4 106.04 345.348 105.775C345.296 105.51 345.323 105.235 345.428 104.986C345.532 104.737 345.708 104.525 345.933 104.376C346.158 104.227 346.423 104.148 346.693 104.15C347.052 104.15 347.396 104.293 347.649 104.546C347.903 104.8 348.045 105.144 348.045 105.502Z",
    fill: "white"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M231.54 83.0993L208.626 70.7566C208.008 70.4241 207.238 70.655 206.906 71.2723L199.593 84.8472C199.261 85.4645 199.492 86.2345 200.109 86.567L223.023 98.9097C223.64 99.2422 224.41 99.0114 224.743 98.3941L232.055 84.8192C232.388 84.2019 232.157 83.4319 231.54 83.0993Z",
    fill: "#407BFF"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M231.54 83.0993L208.626 70.7566C208.008 70.4241 207.238 70.655 206.906 71.2723L199.593 84.8472C199.261 85.4645 199.492 86.2345 200.109 86.567L223.023 98.9097C223.64 99.2422 224.41 99.0114 224.743 98.3941L232.055 84.8192C232.388 84.2019 232.157 83.4319 231.54 83.0993Z",
    fill: "white"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M206.31 72.3927L213.44 85.7787C213.714 86.2886 214.133 86.7059 214.644 86.9778C215.155 87.2496 215.735 87.3638 216.31 87.3059L231.224 85.8339L216.044 88.0695C215.38 88.1676 214.703 88.0486 214.113 87.7303C213.522 87.4119 213.051 86.9113 212.768 86.3031L206.31 72.3927Z",
    fill: "black"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M188.913 69.9186C189.161 64.8034 192.951 54.4902 197.561 51.3346C202.17 48.179 199.134 52.549 199.134 52.549C199.134 52.549 203.504 48.2986 205.804 48.4274C208.104 48.5562 205.804 51.1874 205.804 51.1874C205.804 51.1874 210.542 48.271 212.722 48.4274C214.903 48.5838 212.722 51.1046 212.722 51.1046C212.722 51.1046 216.605 48.3446 218.178 49.6418C219.751 50.939 198.039 65.2818 195.619 71.1146C193.2 76.9474 188.664 75.0798 188.913 69.9186Z",
    fill: "#407BFF"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M188.913 69.9186C189.161 64.8034 192.951 54.4902 197.561 51.3346C202.17 48.179 199.134 52.549 199.134 52.549C199.134 52.549 203.504 48.2986 205.804 48.4274C208.104 48.5562 205.804 51.1874 205.804 51.1874C205.804 51.1874 210.542 48.271 212.722 48.4274C214.903 48.5838 212.722 51.1046 212.722 51.1046C212.722 51.1046 216.605 48.3446 218.178 49.6418C219.751 50.939 198.039 65.2818 195.619 71.1146C193.2 76.9474 188.664 75.0798 188.913 69.9186Z",
    fill: "white"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M207.57 69.1452L210.468 70.9852C210.514 71.0136 210.549 71.0565 210.567 71.1072C210.586 71.1578 210.586 71.2131 210.569 71.2642C210.552 71.3153 210.519 71.3591 210.474 71.3886C210.429 71.4181 210.375 71.4316 210.321 71.4268L207.276 71.1876L207.534 73.5244C207.541 73.5795 207.531 73.6355 207.504 73.6842C207.477 73.7328 207.435 73.7713 207.384 73.7941C207.333 73.8169 207.276 73.8226 207.222 73.8105C207.168 73.7984 207.119 73.769 207.083 73.7268L205.326 71.758L207.57 69.1452Z",
    fill: "#407BFF"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M207.57 69.1452L210.468 70.9852C210.514 71.0136 210.549 71.0565 210.567 71.1072C210.586 71.1578 210.586 71.2131 210.569 71.2642C210.552 71.3153 210.519 71.3591 210.474 71.3886C210.429 71.4181 210.375 71.4316 210.321 71.4268L207.276 71.1876L207.534 73.5244C207.541 73.5795 207.531 73.6355 207.504 73.6842C207.477 73.7328 207.435 73.7713 207.384 73.7941C207.333 73.8169 207.276 73.8226 207.222 73.8105C207.168 73.7984 207.119 73.769 207.083 73.7268L205.326 71.758L207.57 69.1452Z",
    fill: "white"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M166.86 57.6273C166.86 57.6273 170.872 54.8673 176.934 56.6521C176.934 56.6521 178.673 64.6653 183.448 67.3333C186.07 68.7961 192.482 68.6673 197.561 67.0297C203.587 65.0793 206.531 65.0793 207.626 67.3333C208.72 69.5873 207.506 71.9333 202.897 73.0281C198.288 74.1229 194.617 82.1269 186.272 82.2281C177.928 82.3293 173.494 73.9481 175.6 66.5881C173.606 62.8256 170.572 59.7153 166.86 57.6273Z",
    fill: "#407BFF"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M166.86 57.6273C166.86 57.6273 170.872 54.8673 176.934 56.6521C176.934 56.6521 178.673 64.6653 183.448 67.3333C186.07 68.7961 192.482 68.6673 197.561 67.0297C203.587 65.0793 206.531 65.0793 207.626 67.3333C208.72 69.5873 207.506 71.9333 202.897 73.0281C198.288 74.1229 194.617 82.1269 186.272 82.2281C177.928 82.3293 173.494 73.9481 175.6 66.5881C173.606 62.8256 170.572 59.7153 166.86 57.6273Z",
    fill: "white"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M205.326 68.8508C205.326 68.9326 205.301 69.0127 205.256 69.0808C205.21 69.1489 205.146 69.2019 205.07 69.2333C204.994 69.2646 204.911 69.2728 204.831 69.2568C204.75 69.2408 204.677 69.2014 204.619 69.1435C204.561 69.0856 204.521 69.0118 204.506 68.9315C204.49 68.8512 204.498 68.768 204.529 68.6923C204.56 68.6167 204.613 68.552 204.682 68.5065C204.75 68.461 204.83 68.4368 204.912 68.4368C205.021 68.4368 205.127 68.4804 205.204 68.558C205.282 68.6357 205.326 68.741 205.326 68.8508Z",
    fill: "#263238"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M184.331 75.5858C179.391 76.929 168.406 76.5058 163.99 73.1018C159.574 69.6978 164.652 71.2618 164.652 71.2618C164.652 71.2618 159.27 68.419 158.672 66.1926C158.074 63.9662 161.322 65.3278 161.322 65.3278C161.322 65.3278 157.09 61.7306 156.538 59.6146C155.986 57.4986 159.077 58.7866 159.077 58.7866C159.077 58.7866 155.222 55.953 156.004 54.0486C156.786 52.1442 177.109 68.373 183.393 68.879C189.676 69.385 189.336 74.2242 184.331 75.5858Z",
    fill: "#407BFF"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M184.331 75.5858C179.391 76.929 168.406 76.5058 163.99 73.1018C159.574 69.6978 164.652 71.2618 164.652 71.2618C164.652 71.2618 159.27 68.419 158.672 66.1926C158.074 63.9662 161.322 65.3278 161.322 65.3278C161.322 65.3278 157.09 61.7306 156.538 59.6146C155.986 57.4986 159.077 58.7866 159.077 58.7866C159.077 58.7866 155.222 55.953 156.004 54.0486C156.786 52.1442 177.109 68.373 183.393 68.879C189.676 69.385 189.336 74.2242 184.331 75.5858Z",
    fill: "white"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M151.947 53.2022C151.911 53.2112 151.873 53.2112 151.837 53.2022C150.981 52.8986 150.107 52.6134 149.224 52.3466C149.137 52.3191 149.064 52.2583 149.021 52.1774C148.978 52.0966 148.968 52.0021 148.994 51.9142C149.022 51.8269 149.082 51.7539 149.163 51.7109C149.244 51.6679 149.339 51.6583 149.426 51.6842C150.346 51.951 151.202 52.2454 152.067 52.6042C152.144 52.6306 152.209 52.6836 152.25 52.7538C152.292 52.824 152.306 52.9067 152.292 52.9869C152.277 53.067 152.235 53.1393 152.171 53.1906C152.108 53.242 152.029 53.2689 151.947 53.2666V53.2022Z",
    fill: "#407BFF"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3424 127.876C96.2513 127.876 96.1637 127.841 96.0984 127.777C96.0331 127.714 95.9952 127.627 95.9928 127.536C95.9928 127.445 96.0284 127.357 96.0919 127.292C96.1555 127.227 96.2421 127.189 96.3332 127.186C98.1634 127.16 99.9883 126.982 101.789 126.653C101.879 126.636 101.972 126.656 102.048 126.708C102.123 126.76 102.176 126.839 102.194 126.929C102.203 126.973 102.203 127.02 102.194 127.064C102.185 127.109 102.167 127.152 102.142 127.19C102.116 127.227 102.083 127.26 102.044 127.284C102.006 127.309 101.963 127.326 101.918 127.333C100.078 127.67 98.2127 127.852 96.3424 127.876ZM90.8224 127.582C88.966 127.384 87.1228 127.077 85.3024 126.662C85.2123 126.642 85.1337 126.587 85.0837 126.51C85.0338 126.432 85.0165 126.338 85.0356 126.248C85.0575 126.16 85.113 126.083 85.1903 126.035C85.2676 125.987 85.3607 125.971 85.4496 125.99C87.2412 126.394 89.0531 126.701 90.8776 126.91C90.9594 126.924 91.0339 126.966 91.0875 127.029C91.1412 127.092 91.1707 127.172 91.1707 127.255C91.1707 127.338 91.1412 127.418 91.0875 127.482C91.0339 127.545 90.9594 127.587 90.8776 127.6L90.8224 127.582ZM107.171 125.742C107.105 125.742 107.04 125.723 106.984 125.687C106.929 125.651 106.885 125.6 106.858 125.54C106.838 125.498 106.827 125.453 106.825 125.407C106.823 125.361 106.831 125.315 106.847 125.272C106.863 125.229 106.888 125.19 106.92 125.157C106.952 125.124 106.99 125.097 107.033 125.08C108.704 124.359 110.255 123.388 111.633 122.2C111.703 122.146 111.791 122.121 111.88 122.13C111.968 122.139 112.049 122.181 112.108 122.247C112.166 122.314 112.197 122.4 112.194 122.489C112.192 122.577 112.155 122.662 112.093 122.724C110.66 123.954 109.05 124.962 107.318 125.714C107.267 125.743 107.21 125.758 107.152 125.76L107.171 125.742ZM80.04 125.116C80.0038 125.125 79.9659 125.125 79.9296 125.116C78.1816 124.537 76.4244 123.856 74.7224 123.111C74.647 123.068 74.5903 122.998 74.5634 122.915C74.5365 122.833 74.5414 122.743 74.577 122.664C74.6126 122.585 74.6764 122.522 74.756 122.487C74.8356 122.452 74.9253 122.448 75.0076 122.476C76.682 123.212 78.4116 123.884 80.1504 124.463C80.2365 124.494 80.3069 124.558 80.3465 124.641C80.386 124.723 80.3916 124.818 80.362 124.905C80.336 124.968 80.2913 125.023 80.2338 125.06C80.1764 125.098 80.1088 125.118 80.04 125.116ZM69.92 120.645C69.866 120.662 69.8084 120.662 69.7544 120.645C68.1076 119.725 66.5068 118.732 65.0164 117.692C64.9796 117.666 64.9482 117.633 64.9241 117.595C64.9 117.557 64.8836 117.515 64.8759 117.47C64.8683 117.426 64.8694 117.38 64.8793 117.336C64.8892 117.292 64.9076 117.251 64.9336 117.214C64.9596 117.177 64.9926 117.146 65.0307 117.121C65.0688 117.097 65.1112 117.081 65.1557 117.073C65.2001 117.066 65.2456 117.067 65.2896 117.077C65.3336 117.087 65.3752 117.105 65.412 117.131C66.884 118.152 68.4572 119.137 70.0948 120.047C70.1344 120.069 70.1693 120.099 70.1973 120.135C70.2253 120.17 70.2459 120.211 70.2579 120.255C70.2699 120.298 70.273 120.344 70.2671 120.389C70.2613 120.434 70.2465 120.477 70.2236 120.516C70.1847 120.576 70.129 120.623 70.0634 120.651C69.9979 120.679 69.9256 120.686 69.8556 120.673L69.92 120.645ZM115.405 118.539C115.351 118.555 115.293 118.555 115.239 118.539C115.2 118.517 115.165 118.487 115.137 118.451C115.109 118.416 115.088 118.375 115.076 118.331C115.064 118.287 115.061 118.242 115.067 118.197C115.073 118.152 115.088 118.108 115.11 118.069C115.396 117.573 115.662 117.057 115.902 116.524C116.414 115.397 116.814 114.223 117.098 113.019C117.122 112.93 117.179 112.853 117.258 112.805C117.336 112.757 117.431 112.741 117.521 112.761C117.61 112.785 117.685 112.843 117.732 112.922C117.778 113.001 117.792 113.095 117.769 113.184C117.469 114.429 117.053 115.642 116.527 116.809C116.279 117.361 116.003 117.904 115.708 118.419C115.669 118.478 115.613 118.523 115.547 118.55C115.482 118.576 115.409 118.582 115.34 118.566L115.405 118.539ZM60.8488 114.288C60.7679 114.287 60.6898 114.258 60.628 114.205C59.2269 112.968 57.9143 111.634 56.6996 110.213C56.6361 110.148 56.6006 110.06 56.6006 109.969C56.6006 109.878 56.6361 109.79 56.6996 109.725C56.7633 109.662 56.8493 109.627 56.9388 109.627C57.0284 109.627 57.1143 109.662 57.178 109.725C58.3707 111.116 59.6587 112.423 61.0328 113.635C61.0963 113.7 61.1319 113.788 61.1319 113.879C61.1319 113.97 61.0963 114.057 61.0328 114.123C61.01 114.172 60.9755 114.216 60.9323 114.25C60.889 114.283 60.8383 114.306 60.7844 114.316L60.8488 114.288ZM118.054 107.904C118.009 107.904 117.964 107.895 117.922 107.877C117.88 107.859 117.842 107.833 117.81 107.801C117.779 107.768 117.754 107.73 117.737 107.687C117.721 107.645 117.713 107.6 117.714 107.554C117.701 105.725 117.531 103.899 117.208 102.099C117.192 102.008 117.212 101.915 117.263 101.84C117.315 101.764 117.394 101.712 117.484 101.694C117.575 101.68 117.668 101.702 117.744 101.755C117.819 101.809 117.871 101.889 117.889 101.979C118.22 103.819 118.392 105.684 118.404 107.554C118.404 107.647 118.367 107.736 118.302 107.801C118.236 107.867 118.147 107.904 118.054 107.904ZM116.214 96.9928C116.14 96.992 116.068 96.9675 116.008 96.9229C115.949 96.8782 115.905 96.8157 115.883 96.7444C115.414 95.1344 114.834 93.4233 114.126 91.5097C114.108 91.467 114.1 91.4211 114.1 91.3748C114.101 91.3286 114.111 91.283 114.13 91.2408C114.149 91.1986 114.177 91.1607 114.211 91.1295C114.245 91.0982 114.285 91.0742 114.328 91.0589C114.414 91.0289 114.508 91.0332 114.59 91.0709C114.672 91.1087 114.737 91.1769 114.77 91.2613C115.488 93.1933 116.067 94.9412 116.546 96.542C116.572 96.6298 116.562 96.7243 116.519 96.8052C116.476 96.886 116.403 96.9468 116.316 96.9744L116.214 96.9928ZM112.406 86.5511C112.342 86.5516 112.279 86.5336 112.225 86.4993C112.171 86.465 112.129 86.4159 112.102 86.3579C111.513 84.8859 110.713 83.1932 109.876 81.3992V81.3072C109.852 81.227 109.857 81.1409 109.891 81.0645C109.926 80.9881 109.986 80.9264 110.062 80.8908C110.137 80.8552 110.223 80.8479 110.304 80.8703C110.385 80.8927 110.455 80.9433 110.501 81.0128V81.1048C111.348 82.9448 112.139 84.6099 112.728 86.0543C112.765 86.141 112.766 86.2388 112.732 86.3266C112.697 86.4144 112.63 86.4852 112.544 86.5235L112.406 86.5511ZM107.806 76.4314C107.738 76.4335 107.671 76.4154 107.614 76.3793C107.556 76.3433 107.511 76.2909 107.484 76.229C106.656 74.3062 105.993 72.6043 105.469 71.0311C105.439 70.9445 105.445 70.8497 105.484 70.7671C105.524 70.6845 105.594 70.6208 105.68 70.5895C105.768 70.5604 105.864 70.5673 105.947 70.6087C106.03 70.6501 106.093 70.7226 106.122 70.8103C106.637 72.3651 107.29 74.0486 108.118 75.953C108.136 75.9946 108.146 76.0394 108.147 76.0848C108.147 76.1301 108.138 76.1751 108.121 76.2171C108.104 76.2591 108.079 76.2973 108.047 76.3293C108.015 76.3614 107.976 76.3867 107.934 76.4038C107.904 76.4364 107.866 76.4616 107.824 76.4774L107.806 76.4314ZM104.438 65.8885C104.356 65.8874 104.277 65.8572 104.215 65.8033C104.152 65.7495 104.111 65.6754 104.098 65.5941C103.94 64.6084 103.86 63.6117 103.859 62.6134C103.851 61.7214 103.931 60.8309 104.098 59.9547C104.125 59.873 104.18 59.804 104.254 59.7608C104.328 59.7175 104.416 59.703 104.5 59.7201C104.584 59.7371 104.659 59.7845 104.71 59.8532C104.762 59.9219 104.786 60.0072 104.779 60.0927C104.62 60.9233 104.543 61.7676 104.549 62.6134C104.552 63.5777 104.629 64.5403 104.779 65.4929C104.79 65.5826 104.767 65.6733 104.714 65.7466C104.661 65.8199 104.582 65.8706 104.494 65.8885H104.438ZM106.84 55.4376C106.76 55.4398 106.681 55.4137 106.619 55.364C106.555 55.2987 106.52 55.2113 106.52 55.1202C106.52 55.0291 106.555 54.9417 106.619 54.8764C107.854 53.4335 109.357 52.2432 111.044 51.3713C111.125 51.3284 111.219 51.3188 111.307 51.3446C111.394 51.3704 111.469 51.4295 111.513 51.5093C111.553 51.5916 111.56 51.6859 111.533 51.7731C111.505 51.8603 111.446 51.9337 111.366 51.9785C109.759 52.8094 108.328 53.9434 107.152 55.318C107.122 55.3688 107.079 55.4108 107.027 55.4399C106.976 55.4689 106.917 55.484 106.858 55.4836L106.84 55.4376ZM143.934 50.9297H143.86C142.094 50.5617 140.263 50.249 138.414 50.0098C138.369 50.0041 138.326 49.9896 138.287 49.967C138.247 49.9444 138.213 49.9143 138.186 49.8783C138.158 49.8424 138.138 49.8013 138.127 49.7575C138.116 49.7137 138.113 49.6681 138.12 49.6234C138.125 49.5785 138.14 49.5352 138.162 49.496C138.185 49.4568 138.215 49.4225 138.251 49.3951C138.287 49.3677 138.328 49.3477 138.372 49.3364C138.416 49.325 138.461 49.3225 138.506 49.329C140.346 49.5682 142.186 49.881 144.026 50.249C144.109 50.268 144.181 50.3163 144.231 50.3849C144.281 50.4535 144.304 50.5378 144.296 50.6221C144.288 50.7064 144.25 50.785 144.188 50.8433C144.127 50.9015 144.046 50.9355 143.962 50.9389L143.934 50.9297ZM116.334 50.1478C116.289 50.1526 116.244 50.1486 116.201 50.1359C116.158 50.1233 116.118 50.1023 116.083 50.0741C116.048 50.0459 116.018 50.0111 115.997 49.9716C115.975 49.9322 115.962 49.8889 115.957 49.8442C115.952 49.7995 115.956 49.7542 115.969 49.7111C115.981 49.668 116.002 49.6277 116.03 49.5927C116.059 49.5577 116.094 49.5285 116.133 49.507C116.172 49.4854 116.216 49.4718 116.26 49.467C118.077 49.0594 119.923 48.7918 121.78 48.6666C121.872 48.6615 121.961 48.6924 122.03 48.7526C122.099 48.8127 122.141 48.8975 122.148 48.9886C122.152 49.034 122.147 49.0798 122.132 49.1231C122.118 49.1664 122.095 49.2065 122.065 49.2408C122.035 49.2751 121.999 49.303 121.958 49.3229C121.917 49.3428 121.872 49.3543 121.826 49.3566C119.999 49.4747 118.184 49.7362 116.398 50.1386L116.334 50.1478ZM132.894 49.5038C131.293 49.3934 129.389 49.2738 127.374 49.237C127.283 49.2346 127.196 49.1967 127.133 49.1314C127.069 49.0661 127.034 48.9785 127.034 48.8874C127.034 48.8419 127.043 48.7969 127.06 48.755C127.078 48.7131 127.104 48.6751 127.137 48.6434C127.169 48.6117 127.208 48.5868 127.25 48.5702C127.292 48.5537 127.338 48.5458 127.383 48.547C129.416 48.593 131.339 48.7034 132.903 48.8138C132.949 48.8161 132.993 48.8275 133.034 48.8474C133.075 48.8673 133.112 48.8953 133.142 48.9296C133.172 48.9639 133.195 49.0039 133.209 49.0473C133.224 49.0906 133.229 49.1363 133.225 49.1818C133.232 49.2649 133.209 49.3476 133.16 49.4151C133.111 49.4825 133.039 49.5303 132.958 49.5498L132.894 49.5038Z",
    fill: "#407BFF"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6909 105.797C53.6292 105.798 53.5684 105.782 53.5149 105.752C53.4614 105.721 53.4173 105.676 53.3873 105.622C52.9221 104.815 52.5073 103.979 52.1453 103.12C52.1273 103.078 52.1177 103.033 52.1172 102.988C52.1167 102.943 52.1253 102.898 52.1424 102.856C52.1596 102.814 52.1849 102.776 52.217 102.744C52.2491 102.711 52.2873 102.686 52.3293 102.669C52.4136 102.635 52.5079 102.635 52.592 102.67C52.6762 102.704 52.7436 102.77 52.7801 102.853C53.1354 103.685 53.5378 104.496 53.9853 105.282C54.0197 105.333 54.0391 105.393 54.0413 105.454C54.0435 105.516 54.0285 105.577 53.9979 105.631C53.9673 105.684 53.9223 105.728 53.8681 105.758C53.8139 105.787 53.7525 105.801 53.6909 105.797Z",
    fill: "#407BFF"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M165.425 178.511H130.502V185.669H165.425V178.511Z",
    fill: "white"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M165.425 178.511H130.502V185.669H165.425V178.511Z",
    fill: "black"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M145.213 178.511H130.502V185.669H145.213V178.511Z",
    fill: "black"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M130.502 179.542H161.589L130.502 180.425V179.542Z",
    fill: "black"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M165.425 180.784L138.478 181.455H165.425V180.784Z",
    fill: "black"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M131.928 182.789L145.213 182.247L164.744 182.789L145.213 183.093L131.928 182.789Z",
    fill: "black"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M130.502 184.307H153.52L130.502 184.85V184.307Z",
    fill: "black"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M165.37 184.85L149.997 185.135H165.425L165.37 184.85Z",
    fill: "black"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M160.568 171.354H125.645V178.512H160.568V171.354Z",
    fill: "white"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M160.568 171.354H125.645V178.512H160.568V171.354Z",
    fill: "black"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.355 171.354H125.645V178.512H140.355V171.354Z",
    fill: "black"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M125.645 172.384H156.731L125.645 173.258V172.384Z",
    fill: "black"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M160.568 173.626L133.621 174.298H160.568V173.626Z",
    fill: "black"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M127.061 175.632L140.346 175.08L159.878 175.632L140.346 175.936L127.061 175.632Z",
    fill: "black"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M125.645 177.141H148.663L125.645 177.693V177.141Z",
    fill: "black"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M160.512 177.693L145.139 177.978H160.568L160.512 177.693Z",
    fill: "black"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M164.551 164.188H129.628V171.345H164.551V164.188Z",
    fill: "white"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M164.551 164.188H129.628V171.345H164.551V164.188Z",
    fill: "black"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M144.339 164.188H129.628V171.345H144.339V164.188Z",
    fill: "black"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129.628 165.218H160.715L129.628 166.101V165.218Z",
    fill: "black"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M164.551 166.46L137.604 167.131H164.551V166.46Z",
    fill: "black"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M131.054 168.465L144.339 167.923L163.871 168.465L144.339 168.769L131.054 168.465Z",
    fill: "black"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129.628 169.983H152.647L129.628 170.526V169.983Z",
    fill: "black"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M164.505 170.526L149.132 170.811H164.551L164.505 170.526Z",
    fill: "black"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M187.818 185.522L188.72 182.09H226.035L243.211 183.81L243.865 185.522H187.818Z",
    fill: "#263238"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M226.035 182.09V185.522H187.818L188.72 182.09H226.035Z",
    fill: "black"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M218.537 165.669C218.587 166.085 218.547 166.507 218.421 166.906C218.294 167.305 218.083 167.673 217.802 167.984C217.522 168.295 217.178 168.543 216.793 168.71C216.409 168.877 215.994 168.96 215.575 168.953H158.424C157.53 168.933 156.674 168.589 156.016 167.985C155.357 167.381 154.941 166.557 154.845 165.669L151.451 129.081C151.414 128.724 151.439 128.363 151.524 128.014C151.683 127.372 152.055 126.802 152.58 126.399C153.105 125.996 153.751 125.784 154.413 125.797H211.6C212.494 125.816 213.35 126.16 214.008 126.765C214.667 127.369 215.083 128.193 215.179 129.081L218.537 165.669Z",
    fill: "#263238"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M215.372 168.953H158.424C157.53 168.934 156.674 168.59 156.016 167.985C155.357 167.381 154.941 166.557 154.845 165.669L151.451 129.081C151.414 128.724 151.439 128.363 151.524 128.014H208.472C209.366 128.034 210.222 128.378 210.88 128.982C211.539 129.586 211.955 130.41 212.051 131.298L215.446 167.886C215.482 168.243 215.458 168.604 215.372 168.953Z",
    fill: "black"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M176.107 146.515H187.929L184.782 180.361L203.477 183.166V185.522H164.101V183.166L172.169 180.361L176.107 146.515Z",
    fill: "#263238"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.928 146.515L179.17 184.988L172.169 184.776L176.106 146.515H187.928Z",
    fill: "white"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M187.873 333.094H182.243L172.114 192.109H179.593L187.873 333.094Z",
    fill: "#263238"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M187.882 333.094H182.243L172.61 199.119L172.114 192.339H179.593L179.998 199.119L187.882 333.094Z",
    fill: "white"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M179.998 198.779H172.61L172.114 192.339H179.593L179.998 198.779Z",
    fill: "black"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M229.236 333.094H223.606L222.686 192.109H230.156L229.236 333.094Z",
    fill: "#263238"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.166 192.339L230.018 215.089L229.246 333.094H223.606L222.833 215.089L222.686 192.339H230.166Z",
    fill: "white"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.166 192.339L230.018 215.339H222.833L222.686 192.339H230.166Z",
    fill: "black"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M289.073 333.094H283.443L273.314 192.109H280.793L289.073 333.094Z",
    fill: "#263238"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M289.083 333.094H283.443L273.811 199.119L273.314 192.339H280.793L281.198 199.119L289.083 333.094Z",
    fill: "white"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M281.198 198.779H273.811L273.314 192.339H280.793L281.198 198.779Z",
    fill: "black"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M123.4 333.094H117.769L126.049 192.109H133.529L123.4 333.094Z",
    fill: "#263238"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M133.529 192.339L133.032 199.119L123.4 333.094H117.769L125.644 199.119L126.049 192.339H133.529Z",
    fill: "white"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126.049 192.339H133.529L133.032 198.779H125.645L126.049 192.339Z",
    fill: "black"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M120.125 188.594H286.718V193.664C286.718 193.925 286.667 194.183 286.567 194.424C286.467 194.665 286.321 194.884 286.136 195.069C285.952 195.253 285.732 195.4 285.491 195.5C285.25 195.599 284.992 195.651 284.731 195.651H122.112C121.585 195.651 121.079 195.441 120.707 195.069C120.334 194.696 120.125 194.191 120.125 193.664V188.594Z",
    fill: "#407BFF"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M120.125 188.594H286.718V193.664C286.718 193.925 286.667 194.183 286.567 194.424C286.467 194.665 286.321 194.884 286.136 195.069C285.952 195.253 285.732 195.4 285.491 195.5C285.25 195.599 284.992 195.651 284.731 195.651H122.112C121.585 195.651 121.079 195.441 120.707 195.069C120.334 194.696 120.125 194.191 120.125 193.664V188.594Z",
    fill: "white"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M286.718 188.585H120.125V192.118H286.718V188.585Z",
    fill: "black"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M290.214 189.515H116.629C116.102 189.515 115.596 189.305 115.223 188.932C114.851 188.56 114.641 188.054 114.641 187.527C114.641 186.999 114.85 186.493 115.223 186.119C115.595 185.745 116.101 185.533 116.629 185.531H290.214C290.742 185.533 291.247 185.745 291.62 186.119C291.992 186.493 292.201 186.999 292.201 187.527C292.201 188.054 291.992 188.56 291.619 188.932C291.247 189.305 290.741 189.515 290.214 189.515Z",
    fill: "#407BFF"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M290.214 189.515H116.629C116.102 189.515 115.596 189.305 115.223 188.932C114.851 188.56 114.641 188.054 114.641 187.527C114.641 186.999 114.85 186.493 115.223 186.119C115.595 185.745 116.101 185.533 116.629 185.531H290.214C290.742 185.533 291.247 185.745 291.62 186.119C291.992 186.493 292.201 186.999 292.201 187.527C292.201 188.054 291.992 188.56 291.619 188.932C291.247 189.305 290.741 189.515 290.214 189.515Z",
    fill: "white"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M249.145 179.395L251.28 176.193C251.49 175.879 251.775 175.621 252.109 175.443C252.442 175.265 252.815 175.172 253.193 175.172H255.898C256.123 175.173 256.346 175.207 256.56 175.273L266.211 178.199C266.76 178.362 267.226 178.727 267.518 179.22L268.907 181.548L249.145 179.395Z",
    fill: "#407BFF"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.907 181.548L254.84 180.02L249.127 179.395L251.261 176.193C251.472 175.879 251.756 175.621 252.09 175.443C252.424 175.265 252.797 175.172 253.175 175.172H255.88C256.107 175.173 256.333 175.207 256.551 175.273L256.763 175.338L266.193 178.199C266.744 178.361 267.214 178.726 267.509 179.22L268.907 181.548Z",
    fill: "black"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.907 181.547L254.84 180.02L256.763 175.337L266.193 178.199C266.744 178.361 267.214 178.726 267.508 179.22L268.907 181.547Z",
    fill: "black"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M275.586 185.218V185.522H245.76L246.864 181.207C247.068 180.414 247.531 179.713 248.18 179.213C248.828 178.713 249.624 178.444 250.443 178.447H263.672C264.112 178.445 264.548 178.523 264.96 178.677L266.616 179.293L273.185 181.741C273.894 182.003 274.505 182.478 274.935 183.1C275.364 183.723 275.592 184.462 275.586 185.218Z",
    fill: "#407BFF"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M275.586 185.218V185.522H263.341L263.994 180.857C264.036 180.568 264.142 180.292 264.305 180.049C264.467 179.806 264.682 179.603 264.934 179.454C265.185 179.305 265.466 179.214 265.758 179.188C266.049 179.162 266.342 179.201 266.616 179.303L273.185 181.75C273.892 182.012 274.502 182.485 274.931 183.106C275.361 183.726 275.589 184.464 275.586 185.218Z",
    fill: "black"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M265.245 182.357L269.146 170.664C269.184 170.545 269.248 170.435 269.333 170.344C269.418 170.252 269.522 170.179 269.637 170.132C269.753 170.085 269.878 170.063 270.003 170.069C270.128 170.076 270.25 170.109 270.361 170.167C270.53 170.264 270.664 170.413 270.744 170.592C270.823 170.771 270.844 170.97 270.802 171.161L267.518 183.636C267.518 183.636 265.337 184.519 265.245 182.357Z",
    fill: "#263238"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.145 184.556H247.416L247.747 182.854H249.476L249.145 184.556Z",
    fill: "black"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M251.721 184.491H249.992L250.323 182.789H252.052L251.721 184.491Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.3b0108115dad724c82448540bbccdc86.svg";
export { ForwardRef as ReactComponent };